import { Component, OnInit, NgModule, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormsModule, FormArray } from '@angular/forms';
import { CrudService } from './../../../crud/crud.service';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { createAutoCorrectedDatePipe } from 'text-mask-addons';
import { Location } from '@angular/common';
import { Mensaje } from '../../../mensaje';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ConfiguracionSucursalRoutingModule } from 'app/sistema/configuracion-sucursal/sucursal-routing.module';

import * as jQuery from 'jquery';
import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable';
import * as moment from 'moment';
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';

import { JwtRequestService } from 'app/jwt-request.service';
import { environment } from 'environments/environment';
import { map, tap } from 'rxjs/operators';
import { delay, result, toInteger } from 'lodash';


@Component({
  selector: 'app-preinscripcion',
  templateUrl: './formulario.component.html'
})
export class PreinscripcionComponent implements OnInit {
  public dato: FormGroup;
  data: FormGroup;
  guardado: boolean = false;
  cargando: boolean = false;
  url_editar: string = '';
  url_nuevo: string = '';
  carpeta;
  modulo;
  controlador;
  prueba;
  datos_grupos: any[] = [{ 'carreras': ['nombre'] }];
  API_PATH = environment.API_PATH;
  API_URL = environment.API_URL;

  documentos = [];
  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  usuario = JSON.parse(localStorage.getItem("usuario"));
  logo_sucursal = "";
  logo_empresa = "";
  intento3 = 0;

  tab = 1;
  tab2 = 1;
  tamano = document.body.clientHeight;
  permisos;
  grupos: any[] = [];
  planes_pagos;
  pais = 1;
  total_alumnos = 0;
  capacidad_grupo = 0;
  form_preinscripciones_rfcs;
  form_preinscripciones_requisitos;
  tieneid = null;
  planes_pagos_id;
  datosCargados: boolean = true;
  grupo_selecionado;
  beca_texto = '';
  plan_seleccionado = [];

  /*
  beca_seleccionado = {
    id: '',
    nombre: '',
    es_porcentaje: 0,
    becas_detalles_articulos: [
      { 1: { importe: 0, total: 0 } },
      { 2: { importe: 0, total: 0 } },
      { 3: { importe: 0, total: 0 } },
      { 4: { importe: 0, total: 0 } }
    ]
  }; */
  beca_seleccionado = {
    id: '',
    nombre: '',
    es_porcentaje: 0,
    becas_detalles_articulos: [
      { 'db61c2cb92dde2df6e62b4b0744f9dce': { importe: 0, total: 0 }},
      { '83dae74b6269ce625f4babc3fa613be2': { importe: 0, total: 0 }},
      { '12a00afca32cafa9f493f73f2b7f8bcf': { importe: 0, total: 0 }},
      { '549ff7cf2b0d4d82ca99ca7999263207': { importe: 0, total: 0 }}
    ]
  };

  modulo_actual;
  icono;
  estados_civiles =
    [
      { id: 1, descripcion: "Soltero(a)" },
      { id: 2, descripcion: "Casado(a)" },
      { id: 3, descripcion: "Viudo(a)" },
      { id: 4, descripcion: "Divorciado(a)" },
      { id: 5, descripcion: "Unión libre" },
      { id: 6, descripcion: "Comprometido(a)" }
    ];

  idiomas =
    [
      { id: 1, descripcion: 'Español' },
      { id: 2, descripcion: 'Otro' },
    ];

  necesidades_especiales =
    [
      { id: 1, descripcion: 'No aplica' },
      { id: 2, descripcion: 'Con discapacidad' },
      { id: 3, descripcion: 'Con aptitudes sobresalientes' },
    ];

  tipos_de_sangre =
    [
      { id: 1, descripcion: 'A' },
      { id: 2, descripcion: 'B' },
      { id: 3, descripcion: 'AB' },
      { id: 4, descripcion: 'O' }
    ];

  factor_rh =
    [
      { id: 1, descripcion: '+' },
      { id: 2, descripcion: '-' },
    ];

  parentescos =
    [
      { id: 1, descripcion: 'Padre' },
      { id: 2, descripcion: 'Madre' },
      { id: 3, descripcion: 'Otro' },
    ];

  tipos_promocion =
    [
      { id: 1, descripcion: 'Radio' },
      { id: 2, descripcion: 'Tv' },
      { id: 3, descripcion: 'Anuncios y espectaculares' },
      { id: 4, descripcion: 'Periodicos y revistas' },
      { id: 5, descripcion: 'Redes sociales' },
      { id: 6, descripcion: 'Familia y amigos' },
      { id: 7, descripcion: 'Otros' }
    ];

estados_nacimiento = [
  { id: 1, nombre: 'AGUASCALIENTES' },
  { id: 2, nombre: 'BAJA CALIFORNIA' },
  { id: 3, nombre: 'BAJA CALIFORNIA SUR' },
  { id: 4, nombre: 'CAMPECHE' },
  { id: 5, nombre: 'CHIAPAS' },
  { id: 6, nombre: 'CHIHUAHUA' },
  { id: 7, nombre: 'CIUDAD DE MÉXICO' },
  { id: 8, nombre: 'COAHUILA DE ZARAGOZA' },
  { id: 9, nombre: 'COLIMA' },
  { id: 10, nombre: 'DURANGO' },
  { id: 11, nombre: 'GUANAJUATO' },
  { id: 12, nombre: 'GUERRERO' },
  { id: 13, nombre: 'HIDALGO' },
  { id: 14, nombre: 'JALISCO' },
  { id: 15, nombre: 'MÉXICO' },
  { id: 16, nombre: 'MICHOACÁN DE OCAMPO' },
  { id: 17, nombre: 'MORELOS' },
  { id: 18, nombre: 'NAYARIT' },
  { id: 19, nombre: 'NUEVO LEÓN' },
  { id: 20, nombre: 'OAXACA' },
  { id: 21, nombre: 'PUEBLA' },
  { id: 22, nombre: 'QUERÉTARO' },
  { id: 23, nombre: 'QUINTANA ROO' },
  { id: 24, nombre: 'SAN LUIS POTOSÍ' },
  { id: 25, nombre: 'SINALOA' },
  { id: 26, nombre: 'SONORA' },
  { id: 27, nombre: 'TABASCO' },
  { id: 28, nombre: 'TAMAULIPAS' },
  { id: 29, nombre: 'TLAXCALA' },
  { id: 30, nombre: 'VERACRUZ DE IGNACIO DE LA LLAVE' },
  { id: 31, nombre: 'YUCATÁN' },
  { id: 32, nombre: 'ZACATECAS' },
  { id: 33, nombre: 'NACIDO EN EL EXTRANJERO' }
];

  paises_nacimiento = [
  { id: 1, nombre: 'Afganistán' },
  { id: 2, nombre: 'Albania' },
  { id: 3, nombre: 'Alemania' },
  { id: 4, nombre: 'Andorra' },
  { id: 5, nombre: 'Angola' },
  { id: 6, nombre: 'Antigua y Barbuda' },
  { id: 7, nombre: 'Arabia Saudita' },
  { id: 8, nombre: 'Argelia' },
  { id: 9, nombre: 'Argentina' },
  { id: 10, nombre: 'Armenia' },
  { id: 11, nombre: 'Australia' },
  { id: 12, nombre: 'Austria' },
  { id: 13, nombre: 'Azerbaiyán' },
  { id: 14, nombre: 'Bahamas' },
  { id: 15, nombre: 'Bangladés' },
  { id: 16, nombre: 'Barbados' },
  { id: 17, nombre: 'Baréin' },
  { id: 18, nombre: 'Bélgica' },
  { id: 19, nombre: 'Belice' },
  { id: 20, nombre: 'Benín' },
  { id: 21, nombre: 'Bielorrusia' },
  { id: 22, nombre: 'Bolivia' },
  { id: 23, nombre: 'Bosnia y Herzegovina' },
  { id: 24, nombre: 'Botsuana' },
  { id: 25, nombre: 'Brasil' },
  { id: 26, nombre: 'Brunéi' },
  { id: 27, nombre: 'Bulgaria' },
  { id: 28, nombre: 'Burkina Faso' },
  { id: 29, nombre: 'Burundi' },
  { id: 30, nombre: 'Bután' },
  { id: 31, nombre: 'Cabo Verde' },
  { id: 32, nombre: 'Camboya' },
  { id: 33, nombre: 'Camerún' },
  { id: 34, nombre: 'Canadá' },
  { id: 35, nombre: 'Catar' },
  { id: 36, nombre: 'Chad' },
  { id: 37, nombre: 'Chile' },
  { id: 38, nombre: 'China' },
  { id: 39, nombre: 'Chipre' },
  { id: 40, nombre: 'Colombia' },
  { id: 41, nombre: 'Comoras' },
  { id: 42, nombre: 'Corea del Norte' },
  { id: 43, nombre: 'Corea del Sur' },
  { id: 44, nombre: 'Costa de Marfil' },
  { id: 45, nombre: 'Costa Rica' },
  { id: 46, nombre: 'Croacia' },
  { id: 47, nombre: 'Cuba' },
  { id: 48, nombre: 'Dinamarca' },
  { id: 49, nombre: 'Dominica' },
  { id: 50, nombre: 'Ecuador' },
  { id: 51, nombre: 'Egipto' },
  { id: 52, nombre: 'El Salvador' },
  { id: 53, nombre: 'Emiratos Árabes Unidos' },
  { id: 54, nombre: 'Eritrea' },
  { id: 55, nombre: 'Eslovaquia' },
  { id: 56, nombre: 'Eslovenia' },
  { id: 57, nombre: 'España' },
  { id: 58, nombre: 'Estados Unidos' },
  { id: 59, nombre: 'Estonia' },
  { id: 60, nombre: 'Etiopía' },
  { id: 61, nombre: 'Filipinas' },
  { id: 62, nombre: 'Finlandia' },
  { id: 63, nombre: 'Fiyi' },
  { id: 64, nombre: 'Francia' },
  { id: 65, nombre: 'Gabón' },
  { id: 66, nombre: 'Gambia' },
  { id: 67, nombre: 'Georgia' },
  { id: 68, nombre: 'Ghana' },
  { id: 69, nombre: 'Granada' },
  { id: 70, nombre: 'Grecia' },
  { id: 71, nombre: 'Guatemala' },
  { id: 72, nombre: 'Guinea' },
  { id: 73, nombre: 'Guinea Ecuatorial' },
  { id: 74, nombre: 'Guinea-Bissau' },
  { id: 75, nombre: 'Guyana' },
  { id: 76, nombre: 'Haití' },
  { id: 77, nombre: 'Honduras' },
  { id: 78, nombre: 'Hungría' },
  { id: 79, nombre: 'India' },
  { id: 80, nombre: 'Indonesia' },
  { id: 81, nombre: 'Irak' },
  { id: 82, nombre: 'Irán' },
  { id: 83, nombre: 'Irlanda' },
  { id: 84, nombre: 'Islandia' },
  { id: 85, nombre: 'Israel' },
  { id: 86, nombre: 'Italia' },
  { id: 87, nombre: 'Jamaica' },
  { id: 88, nombre: 'Japón' },
  { id: 89, nombre: 'Jordania' },
  { id: 90, nombre: 'Kazajistán' },
  { id: 91, nombre: 'Kenia' },
  { id: 92, nombre: 'Kirguistán' },
  { id: 93, nombre: 'Kiribati' },
  { id: 94, nombre: 'Kuwait' },
  { id: 95, nombre: 'Laos' },
  { id: 96, nombre: 'Lesoto' },
  { id: 97, nombre: 'Letonia' },
  { id: 98, nombre: 'Líbano' },
  { id: 99, nombre: 'Liberia' },
  { id: 100, nombre: 'Libia' },
  { id: 101, nombre: 'Liechtenstein' },
  { id: 102, nombre: 'Lituania' },
  { id: 103, nombre: 'Luxemburgo' },
  { id: 104, nombre: 'Madagascar' },
  { id: 105, nombre: 'Malaui' },
  { id: 106, nombre: 'Malasia' },
  { id: 107, nombre: 'Maldivas' },
  { id: 108, nombre: 'Malí' },
  { id: 109, nombre: 'Malta' },
  { id: 110, nombre: 'Marruecos' },
  { id: 111, nombre: 'Marshall, Islas' },
  { id: 112, nombre: 'Mauricio' },
  { id: 113, nombre: 'Mauritania' },
  { id: 114, nombre: 'México' },
  { id: 115, nombre: 'Micronesia' },
  { id: 116, nombre: 'Moldavia' },
  { id: 117, nombre: 'Mónaco' },
  { id: 118, nombre: 'Mongolia' },
  { id: 119, nombre: 'Montenegro' },
  { id: 120, nombre: 'Mozambique' },
  { id: 121, nombre: 'Namibia' },
  { id: 122, nombre: 'Nauru' },
  { id: 123, nombre: 'Nepal' },
  { id: 124, nombre: 'Nicaragua' },
  { id: 125, nombre: 'Níger' },
  { id: 126, nombre: 'Nigeria' },
  { id: 127, nombre: 'Noruega' },
  { id: 128, nombre: 'Nueva Zelanda' },
  { id: 129, nombre: 'Omán' },
  { id: 130, nombre: 'Países Bajos' },
  { id: 131, nombre: 'Pakistán' },
  { id: 132, nombre: 'Palaos' },
  { id: 133, nombre: 'Panamá' },
  { id: 134, nombre: 'Papúa Nueva Guinea' },
  { id: 135, nombre: 'Paraguay' },
  { id: 136, nombre: 'Perú' },
  { id: 137, nombre: 'Polonia' },
  { id: 138, nombre: 'Portugal' },
  { id: 139, nombre: 'Reino Unido' },
  { id: 140, nombre: 'República Centroafricana' },
  { id: 141, nombre: 'República Checa' },
  { id: 142, nombre: 'República del Congo' },
  { id: 143, nombre: 'República Democrática del Congo' },
  { id: 144, nombre: 'República Dominicana' },
  { id: 145, nombre: 'Ruanda' },
  { id: 146, nombre: 'Rumania' },
  { id: 147, nombre: 'Rusia' },
  { id: 148, nombre: 'Samoa' },
  { id: 149, nombre: 'San Cristóbal y Nieves' },
  { id: 150, nombre: 'San Marino' },
  { id: 151, nombre: 'San Vicente y las Granadinas' },
  { id: 152, nombre: 'Santa Lucía' },
  { id: 153, nombre: 'Santo Tomé y Príncipe' },
  { id: 154, nombre: 'Senegal' },
  { id: 155, nombre: 'Serbia' },
  { id: 156, nombre: 'Seychelles' },
  { id: 157, nombre: 'Sierra Leona' },
  { id: 158, nombre: 'Singapur' },
  { id: 159, nombre: 'Siria' },
  { id: 160, nombre: 'Somalia' },
  { id: 161, nombre: 'Sri Lanka' },
  { id: 162, nombre: 'Sudáfrica' },
  { id: 163, nombre: 'Sudán' },
  { id: 164, nombre: 'Sudán del Sur' },
  { id: 165, nombre: 'Suecia' },
  { id: 166, nombre: 'Suiza' },
  { id: 167, nombre: 'Surinam' },
  { id: 168, nombre: 'Tailandia' },
  { id: 169, nombre: 'Tanzania' },
  { id: 170, nombre: 'Tayikistán' },
  { id: 171, nombre: 'Timor Oriental' },
  { id: 172, nombre: 'Togo' },
  { id: 173, nombre: 'Tonga' },
  { id: 174, nombre: 'Trinidad y Tobago' },
  { id: 175, nombre: 'Túnez' },
  { id: 176, nombre: 'Turkmenistán' },
  { id: 177, nombre: 'Turquía' },
  { id: 178, nombre: 'Tuvalu' },
  { id: 179, nombre: 'Ucrania' },
  { id: 180, nombre: 'Uganda' },
  { id: 181, nombre: 'Uruguay' },
  { id: 182, nombre: 'Uzbekistán' },
  { id: 183, nombre: 'Vanuatu' },
  { id: 184, nombre: 'Vaticano' },
  { id: 185, nombre: 'Venezuela' },
  { id: 186, nombre: 'Vietnam' },
  { id: 187, nombre: 'Yemen' },
  { id: 188, nombre: 'Yibuti' },
  { id: 189, nombre: 'Zambia' },
  { id: 190, nombre: 'Zimbabue' }
];





  moduloTitulo: string;
  // Crear la variable que mustra las notificaciones
  mensajeResponse: Mensaje = new Mensaje()
  titulo = 'Preinscripciones';
  @Input() URL: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private crud: CrudService,
    private notificacion: NotificationsService,
    private http: HttpClient,
    private location: Location,) {

  }

  ngOnInit() {
    for (let c = 0; c < 12; c++) {
      this.acordeon[c] = false;
    }

    let url = location.href.split("/");
    this.carpeta = url[4];
    this.modulo = url[5];

    let ctrl = "-" + this.modulo;
    this.controlador = ctrl.toLowerCase()
      // remplazar _ o - por espacios
      .replace(/[-_]+/g, ' ')
      // quitar numeros
      .replace(/[^\w\s]/g, '')
      // cambiar a mayusculas el primer caracter despues de un espacio
      .replace(/ (.)/g, function ($1) {
        return $1.toUpperCase();
      })
      // quitar espacios y agregar controller
      .replace(/ /g, '') + "Controller";
    this.url_nuevo = '/' + this.carpeta + '/' + this.modulo + '/nuevo';
    this.url_editar = this.carpeta + '/' + this.modulo + '/editar/';
    this.dato = this.fb.group({
      id: [''],
      niveles_educativos_id: [this.configuracion.nivel_educativo.id],
      periodos_escolares_id: [''],
      carreras_id: [''],
      carreras_planes_id: [''],
      modalidades_id: [''],
      grupos_id: [''],
      planes_pagos_id: [''],
      becas_id: [''],
      nombre: ['',[Validators.required]],
      apellido_paterno: ['',[Validators.required]],
      apellido_materno: ['',[Validators.required]],
      curp: ['',[Validators.required,Validators.minLength(18)]],
      sexo: [''],
      fecha_nacimiento: ['',[Validators.required]],
      pais_nacimiento: [114],
      estado_nacimiento: [1],
      pais_procedencia: [114],
      municipio_nacimiento: [''],
      inscripcion_condicionada: [1],
      condicion_adicional: [1],
      fecha_condicionada: [''],
      condiciones: [''],
      idioma: [1],
      necesidad_educativa_especial: [1],
      email: ['', [Validators.required, Validators.email]],
      telefono: [''],
      telefono2: [''],
      documentos_validados: [1],
      estado_civil_id: [1],
      formularios_id: [0],
      datos_adicionales: this.fb.group({
        id: [''],
        personas_id: [''],
        domicilio_estado: [''],
        domicilio_municipio: [''],
        domicilio_colonia: [''],
        domicilio_calle: [''],
        domicilio_exterior: [''],
        domicilio_interior: [''],
        domicilio_referencias: [''],
        escuela_procedencia: [''],
        sector_escuela_procedencia: [1],
        medio_promocion: [0],
        tipo_sangre: [''],
        factor_rh: [''],
        alergias: [''],
        presenta_alergias: [''],
        contacto_medico: [''],
        telefono_medico: [''],
        telefono_medico2: [''],
        padecimientos: [''],
        observaciones: ['']
      }),
      datos_tutores: this.fb.group({
        id: [''],
        personas_id: [''],
        nombre: [''],
        parentesco: [''],
        telefono: [''],
        email: [''],
        nombre_2: [''],
        parentesco_2: [''],
        telefono2: [''],
        email2: [''],
        observaciones: ['']
      }),
      preinscripciones_rfcs: this.fb.array([]),
      preinscripciones_requisitos: this.fb.group({})
    });

    //console.log(this.dato.controls.curp.errors);
    
    //this.plan_seleccionado[1] = { importe: 0 };
    //this.plan_seleccionado[2] = { importe: 0 };
    //this.plan_seleccionado[3] = { importe: 0 };
    //this.plan_seleccionado[4] = { importe: 0 };

    this.plan_seleccionado['db61c2cb92dde2df6e62b4b0744f9dce'] = { importe: 0 };
    this.plan_seleccionado['83dae74b6269ce625f4babc3fa613be2'] = { importe: 0 };
    this.plan_seleccionado['12a00afca32cafa9f493f73f2b7f8bcf'] = { importe: 0 };
    this.plan_seleccionado['549ff7cf2b0d4d82ca99ca7999263207'] = { importe: 0 };


    this.route.params.subscribe(params => {
      this.tieneid = params['id'];
      if (this.tieneid) {
        if (this.tieneid == "yo") {
          this.tieneid = JSON.parse(localStorage.getItem("usuario")).id;
        }
        if (!document.getElementById("cargar_datos_dinamicos"))
          this.cargarDatos();
      }
    });

    this.permisos = JSON.parse(localStorage.getItem('permisos'));
    //this.obtenerFormularios("preinscripcion");
    this.obtenerdocumentos("SOLICITUD DE INSCRIPCIÓN " + this.configuracion.nivel_educativo.nombre.toUpperCase());
    this.obtenerdocumentos("SOLICITUD DE INSCRIPCIÓN FIRMAS PIE");
    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
    document.getElementById("cargar_datos_dinamicos").click();
    this.obtenerRequisitos();
    this.obtenerCatalogosDinamicos('paises', this.dato.get('pais_nacimiento'));
    let titulo_icono = this.obtener_icono(url, this.controlador, JSON.parse(localStorage.getItem("menu")));
    this.icono = titulo_icono.icono;
    this.modulo_actual = titulo_icono.titulo;
    this.moduloTitulo = this.tieneid ? "Modificar" : "Nuevo";



    if (!localStorage.getItem('refresh')) {
      localStorage.setItem('refresh', 'no refresh')
      location.reload()
    } else {
      localStorage.removeItem('refresh')
    }



  }

  obtener_icono(url, controlador, menu) {
    menu.map((element, key) => {
      if (typeof this.icono == 'undefined') {

        if (element.path.indexOf('/' + url[5] + '/' + url[6]) > -1 || element.path.indexOf('/' + url[5] + '/lista') > -1) {
          this.icono = element;
          return this.icono;
        }
        if (element.lista) {
          this.icono = this.obtener_icono(url, controlador, element.lista);
          return this.icono;
        }

      }
      else
        return this.icono;
    });
    return this.icono;
  }

  /**
   * Este método selecciona un valor de un select2 y lo pasa al modelo
   * @param valor valor del options del selec seleccionado
   * @param modelo  modelo donde se agrega el valor
   * @return void
   */
  calcular_beca(becas) {
    becas.forEach(element => {
      if (element.id == this.dato.get("becas_id").value) {
        for (let elem in element.becas_detalles_articulos[this.dato.get('carreras_id').value]) {
          element.becas_detalles_articulos[this.dato.get('carreras_id').value][elem].importe = parseFloat(element.becas_detalles_articulos[this.dato.get('carreras_id').value][elem].importe);
          let total = element.becas_detalles_articulos[this.dato.get('carreras_id').value][elem].importe;
          if (element.es_porcentaje) {
            total = element.becas_detalles_articulos[this.dato.get('carreras_id').value][elem].importe / 100;
            total = this.plan_seleccionado[elem].importe * total;
          }
          element.becas_detalles_articulos[this.dato.get('carreras_id').value][elem].total = total;
        }
        this.beca_seleccionado = {
          id: element.id,
          nombre: element.nombre,
          es_porcentaje: element.es_porcentaje,
          becas_detalles_articulos: element.becas_detalles_articulos[this.dato.get('carreras_id').value]
        };
      }
    });
  }



  /**
     * Este método selecciona un valor de un select2 y lo pasa al modelo
     * @param valor valor del options del selec seleccionado
     * @param modelo  modelo donde se agrega el valor
     * @return void
     */
  parametros = {
    pagina: 0,
    limite: 0
  };

  carreras_general;
  modalidades_general;
  periodos_escolares;
  limpiar_mod() {
    this.dato.controls.modalidades_id.patchValue('');
  }
  grupo_campania(carreras, modalidades, carrera, modalidad) {
    this.carreras_general = carreras;
    this.modalidades_general = modalidades;
    carreras.forEach(element => {
      if (modalidad != '' && carrera != '') {
        if (element.id == carrera) {
         
          this.dato.controls.carreras_id.patchValue(element.carreras.id);
          this.crud.lista(this.parametros, 'grupo-campania?modalidades_id=' + modalidad + '&carreras_id=' + carrera).subscribe(
            resultado => {
              this.grupos = resultado.data;
             //this.cargando = false;
              this.planes_pagos = resultado.planes_pagos;


              if (this.dato.controls.grupos_id.value) {
                this.grupos.forEach(element => {
                  this.periodos_escolares = element.periodo_escolar
                  if (this.dato.controls.grupos_id.value == element.id) {
                    this.grupo_selecionado = element;
                    this.plan_seleccionado = this.planes_pagos[element.nivel] != undefined ? this.planes_pagos[element.nivel] : this.planes_pagos[0];
                    //this.dato.controls.planes_pagos_id.patchValue(this.plan_seleccionado[1].planes_pagos_id);
                    //this.planes_pagos_id = this.plan_seleccionado[1].planes_pagos_id;
                    this.dato.controls.planes_pagos_id.patchValue(this.plan_seleccionado['db61c2cb92dde2df6e62b4b0744f9dce'].planes_pagos_id);
                    this.planes_pagos_id = this.plan_seleccionado['db61c2cb92dde2df6e62b4b0744f9dce'].planes_pagos_id;

                  }
                })
              }
            });

          this.grupos = [];
        }
      }
    })

  }





  total_alumno_grupoxxxx() {
    let nivel = 1;
    this.grupos.forEach(element => {
        
      if (this.dato.controls.grupos_id.value == element.id.toString()) {
        this.grupo_selecionado = element;
        this.plan_seleccionado = this.planes_pagos[element.nivel] != undefined ? this.planes_pagos[element.nivel] : this.planes_pagos[0];
        this.total_alumnos = element.total_alumnos;
        this.capacidad_grupo = element.capacidad;

        this.dato.controls.planes_pagos_id.patchValue(this.plan_seleccionado[1].planes_pagos_id);
        this.planes_pagos_id = this.plan_seleccionado[1].planes_pagos_id;
      } else {
        this.total_alumnos = 0;
        this.capacidad_grupo = 0;
      }
    });
  }

    total_alumno_grupo() {

    let nivel = 1;
    this.grupos.forEach(element => {

     // console.log(element);  
      
     if (this.dato.controls.grupos_id.value == element.id)
      {

        console.log('ID-GRUPO-CONTROL-SELECCIONADO '+this.dato.controls.grupos_id.value);
        console.log('ID-ELEMENTO-ITERADO '+element.id);

        this.grupo_selecionado = element;
        this.plan_seleccionado = this.planes_pagos[element.nivel] != undefined ? this.planes_pagos[element.nivel] : this.planes_pagos[0];
        this.total_alumnos = element.total_alumnos;
        this.capacidad_grupo = element.capacidad;

        this.dato.controls.planes_pagos_id.patchValue(this.plan_seleccionado['db61c2cb92dde2df6e62b4b0744f9dce'].planes_pagos_id);
        this.planes_pagos_id = this.plan_seleccionado['db61c2cb92dde2df6e62b4b0744f9dce'].planes_pagos_id;
        //throw "break";

      } 
      
    });
  }

  

  predeterminado(modelo) {

    this.dato.controls.preinscripciones_rfcs['controls'].forEach(element => {
      element.controls.predeterminado.patchValue(0);
    });

    modelo.patchValue(1);
  }

  // mostrar notificaciones configuracion default, posicion abajo izquierda, tiempo 2 segundos
  public options = {
    position: ["bottom", "left"],
    timeOut: 2000,
    lastOnBottom: true
  };

  /**
   * Este método muestra los mensajes resultantes de los llamados de la api
   * @param cuentaAtras numero de segundo a esperar para que el mensaje desaparezca solo
   * @param posicion  array de posicion [vertical, horizontal]
   * @return void
   */
  mensaje(cuentaAtras: number = 6, posicion: any[] = ["bottom", "left"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };
    if (this.mensajeResponse.titulo == '')
      this.mensajeResponse.titulo = this.titulo;

    if (this.mensajeResponse.clase == 'alert')
      this.notificacion.alert(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'success')
      this.notificacion.success(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'info')
      this.notificacion.info(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'warning' || this.mensajeResponse.clase == 'warn')
      this.notificacion.warn(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'error' || this.mensajeResponse.clase == 'danger')
      this.notificacion.error(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

  }
  catalogosDinamicos = [];
  obtenerCatalogosDinamicos(url, id) {
    this.crud.lista(this.parametros, url).subscribe(
      resultado => {

        console.log('>>>>>>>>>>>>>>>>> CATALOGO DINAMICO : [  '+url+' ]');
        console.log('>>>>>>>>>>>>>>>>> CATALOGO DINAMICO RESPONSE : '+resultado);

        resultado.data.forEach(element => {
          if (!element.text) {
            element.text = element.nombre;
          }
        });
        this.catalogosDinamicos[id.value] = resultado.data;
        //console.log(this.catalogosDinamicos[id.value]);
        // this.obtenerCatalogosDependientesDinamicos('estados',this.dato.get('pais_nacimiento'));
        //document.getElementById("depedienteP").click();

      },
      error => {
      }
    );
  }

  obtenerCatalogosDependientesDinamicos(url, id) {
    let operador = "?";
    this.crud.lista(this.parametros, url + operador + "id=" + id).subscribe(
      resultado => {

        console.log('>>>>>>>>>>>>>>>>> CATALOGO DEPENDIENTE DINAMICO : [  '+url+' ]');
        console.log('>>>>>>>>>>>>>>>>> CATALOGO DEPENDIENTE DINAMICO RESPONSE : '+resultado);

        resultado.data.forEach(element => {
          if (!element.text) {
            element.text = element.nombre;
          }
        });

        //console.log(resultado.data);

        this.catalogosDinamicos[id] = resultado.data;


      },
      error => {
      }
    );
  }
  // formularios dinamicos

  formulario = [];
  acordeon = [];

  formularioConstruido = false;
  requisito: any = [];
  secciones_requisitos = [];

  formulario_id;
  obtenerRequisitos() {

    let nivel = this.configuracion.nivel_educativo.id;
    let tipo = "PREINSCRIPCION";

    //console.log(this.configuracion);
    //*se configuro nombre2 y parentesco2 como nombre_2 y parentesco_2
    let json = {
      niveles_id: nivel,
      tipo: tipo
    }
    this.http.post(this.API_PATH + "/formulario-requisito", json).subscribe((resultado: any) => {
      this.requisito = resultado.data;
      for (let index = 0; index < this.requisito.length; index++) {
        const formulario = this.requisito[index];
        formulario.formularios_requisitos.forEach(formuiarios => {

          formuiarios.forEach(element => {
            this.dato.controls.formularios_id.patchValue(element.formularios_id)
            this.formulario_id = element.formularios_id;
            this.dato.controls.preinscripciones_requisitos["controls"][element.id] = new FormControl(false);
          });


        });

      }

    }, e => {
      console.log(e);

    })
  }



  obtenerdocumentos(tipo) {
    this.cargando = true;
    this.crud.lista(this.parametros, "documentos?tipo=" + tipo).subscribe(
      resultado => {
        if (resultado.status == 200) {
          this.documentos[tipo] = resultado.data;
        } else {
          this.mensajeResponse.titulo = "Documentos";
          this.mensajeResponse.texto = "No configurado";
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
        this.mensajeResponse.titulo = "Error";
        this.mensajeResponse.texto = "Documentos";
        this.mensajeResponse.clase = "danger";
        this.mensaje(3);
      }
    );
  }

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
    }
  }

  reset_form() {
    try {
      this.dato.reset();
      for (let item in this.dato.controls) {
        const ctrl = <FormArray>this.dato.controls[item];
        if (ctrl.controls) {
          if (typeof ctrl.controls.length == "number") {
            while (ctrl.length) {
              ctrl.removeAt(ctrl.length - 1);
            }
            ctrl.reset();
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
    return true;
  }

  datoTutor;
  datoRequi;
  datoGenerales;
  folio;
  creado;
  cargarDatos() {
    this.crud.ver(this.tieneid, "preinscripcion").subscribe(resultado => {

      this.cargando = false;
      this.datoGenerales = resultado.data;
      this.creado = resultado.data.created_at
      this.folio = resultado.data.folio;
     
      if (resultado.data.datos_tutores != null) {
        this.datoTutor = resultado.data.datos_tutores;
      } else {
        this.datoTutor = ''
      }
      if (this.tieneid) {
        this.total_alumno_grupo();
        //this.obtenerCatalogosDependientesDinamicos('municipios', resultado.data.estado_nacimiento);
        this.obtenerCatalogosDependientesDinamicos('estados', 1);
        this.obtenerCatalogosDependientesDinamicos('municipios', resultado.data.datos_adicionales.domicilio_estado);
      }
      this.datoRequi = resultado.data.preinscripciones_requisitos;
      this.dato = this.fb.group({
        id: [resultado.data.id],
        niveles_educativos_id: [this.configuracion.nivel_educativo.id],
        periodos_escolares_id: [resultado.data.periodos_escolares_id],
        carreras_id: [resultado.data.carreras_id],
        carreras_planes_id: [resultado.data.carreras_planes_id],
        modalidades_id: [resultado.data.modalidades_id],
        grupos_id: [resultado.data.grupos_id],
        planes_pagos_id: [resultado.data.planes_pagos_id],
        becas_id: [resultado.data.becas_id],
        nombre: [resultado.data.nombre],
        apellido_paterno: [resultado.data.apellido_paterno],
        apellido_materno: [resultado.data.apellido_materno],
        curp: [resultado.data.curp],
        sexo: [resultado.data.sexo],
        fecha_nacimiento: [resultado.data.fecha_nacimiento],
        pais_nacimiento: [resultado.data.pais_nacimiento],
        pais_procedencia: [resultado.data.pais_procedencia],
        estado_nacimiento: [resultado.data.estado_nacimiento], 
        municipio_nacimiento: [resultado.data.municipio_nacimiento],
        inscripcion_condicionada: [resultado.data.inscripcion_condicionada],
        fecha_condicionada: [resultado.data.fecha_condicionada],
        condicion_adicional: [resultado.data.condicion_adicional],
        condiciones: [resultado.data.condicion],
        idioma: [resultado.data.idioma],
        necesidad_educativa_especial: [resultado.data.necesidad_educativa_especial],
        email: [resultado.data.email, [Validators.required, Validators.email]],
        telefono: [resultado.data.telefono],
        telefono2: [resultado.data.telefono2],
        documentos_validados: [1],
        estado_civil_id: [1],
        formularios_id: [this.formulario_id],
        datos_adicionales: this.fb.group({
          id: [resultado.data.datos_adicionales.id],
          personas_id: [resultado.data.id],
          domicilio_estado: [resultado.data.datos_adicionales.domicilio_estado],
          domicilio_municipio: [resultado.data.datos_adicionales.domicilio_municipio],
          domicilio_colonia: [resultado.data.datos_adicionales.domicilio_colonia],
          domicilio_calle: [resultado.data.datos_adicionales.domicilio_calle],
          domicilio_exterior: [resultado.data.datos_adicionales.domicilio_exterior],
          domicilio_interior: [resultado.data.datos_adicionales.domicilio_interior],
          domicilio_referencias: [resultado.data.datos_adicionales.domicilio_exterior],
          escuela_procedencia: [resultado.data.datos_adicionales.escuela_procedencia],
          sector_escuela_procedencia: [resultado.data.datos_adicionales.sector_escuela_procedencia],
          tipo_sangre: [resultado.data.datos_adicionales.tipo_sangre],
          medio_promocion: [resultado.data.datos_adicionales.medio_promocion],
          factor_rh: [resultado.data.datos_adicionales.factor_rh],
          alergias: [resultado.data.datos_adicionales.alergias],
          presenta_alergias: [resultado.data.datos_adicionales.presenta_alergias],
          contacto_medico: [resultado.data.datos_adicionales.contacto_medico],
          telefono_medico: [resultado.data.datos_adicionales.telefono_medico],
          telefono_medico2: [resultado.data.datos_adicionales.telefono_medico2],
          padecimientos: [resultado.data.datos_adicionales.padecimientos],
          observaciones: [resultado.data.datos_adicionales.observaciones]
        }),
        datos_tutores: this.fb.group({
          id: [this.datoTutor.id],
          personas_id: [resultado.data.id],
          nombre: [this.datoTutor.nombre],
          parentesco: [this.datoTutor.parentesco],
          telefono: [this.datoTutor.telefono],
          email: [this.datoTutor.email],
          nombre_2: [this.datoTutor.nombre2],
          parentesco_2: [this.datoTutor.parentesco2],
          telefono2: [this.datoTutor.telefono2],
          email2: [this.datoTutor.email2],
          observaciones: [this.datoTutor.observaciones]
        }),
        preinscripciones_requisitos: this.fb.group(this.datoRequi)
      });

    }, e => {
      console.log(e);

    })

    // this.http.get(this.API_URL + "/preinscripcion/" + this.tieneid).subscribe( result =>{
    //   console.log(result);

    // },e=>{
    //   console.log(e);

    // })
    this.tamano = document.body.clientHeight;
    this.cargando = true;
    // this.http.get(this.API_URL + "/preinscripcion-individual?id=" + this.tieneid + '&tipo=' + tipo + '&nivel_educativo=' + nivel).subscribe((resultado: any) => {
    //   this.cargando = false;
    //   this.datoGenerales = resultado.data;
    //   if (resultado.data.datos_tutores != null) {
    //     this.datoTutor = resultado.data.datos_tutores;
    //   } else {
    //     this.datoTutor = ''
    //   }
    //   if (this.tieneid) {
    //     this.total_alumno_grupo();
    //     this.obtenerCatalogosDependientesDinamicos('municipios', resultado.data.estado_nacimiento);
    //     this.obtenerCatalogosDependientesDinamicos('municipios', resultado.data.datos_adicionales.domicilio_estado);
    //   }
    //   this.datoRequi = resultado.data.preinscripciones_requisitos;
    //   this.dato = this.fb.group({
    //     id: [resultado.data.id],
    //     niveles_educativos_id: [this.configuracion.nivel_educativo.id],
    //     periodos_escolares_id: [resultado.data.periodos_escolares_id],
    //     carreras_id: [resultado.data.carreras_id],
    //     carreras_planes_id: [resultado.data.carreras_planes_id],
    //     modalidades_id: [resultado.data.modalidades_id],
    //     grupos_id: [resultado.data.grupos_id],
    //     planes_pagos_id: [resultado.data.planes_pagos_id],
    //     becas_id: [resultado.data.becas_id],
    //     nombre: [resultado.data.nombre],
    //     apellido_paterno: [resultado.data.apellido_paterno],
    //     apellido_materno: [resultado.data.apellido_materno],
    //     curp: [resultado.data.curp],
    //     sexo: [resultado.data.sexo],
    //     fecha_nacimiento: [resultado.data.fecha_nacimiento],
    //     pais_nacimiento: [resultado.data.pais_nacimiento],
    //     estado_nacimiento: [resultado.data.estado_nacimiento],
    //     municipio_nacimiento: [resultado.data.municipio_nacimiento],
    //     inscripcion_condicionada: [resultado.data.inscripcion_condicionada],
    //     fecha_condicionada: [resultado.data.fecha_condicionada],
    //     condiciones: [resultado.data.condicion],
    //     idioma: [resultado.data.idioma],
    //     necesidad_educativa_especial: [resultado.data.necesidad_educativa_especial],
    //     email: [resultado.data.email, [Validators.required, Validators.email]],
    //     telefono: [resultado.data.telefono],
    //     telefono2: [resultado.data.telefono2],
    //     documentos_validados: [1],
    //     estado_civil_id: [1],
    //     formularios_id: [this.formulario_id],
    //     datos_adicionales: this.fb.group({
    //       personas_id: [resultado.data.id],
    //       domicilio_estado: [resultado.data.datos_adicionales.domicilio_estado],
    //       domicilio_municipio: [resultado.data.datos_adicionales.domicilio_municipio],
    //       domicilio_colonia: [resultado.data.datos_adicionales.domicilio_colonia],
    //       domicilio_calle: [resultado.data.datos_adicionales.domicilio_calle],
    //       domicilio_exterior: [resultado.data.datos_adicionales.domicilio_exterior],
    //       domicilio_interior: [resultado.data.datos_adicionales.domicilio_interior],
    //       domicilio_referencias: [resultado.data.datos_adicionales.domicilio_exterior],
    //       escuela_procedencia: [resultado.data.datos_adicionales.escuela_procedencia],
    //       sector_escuela_procedencia: [resultado.data.datos_adicionales.sector_escuela_procedencia],
    //       tipo_sangre: [resultado.data.datos_adicionales.tipo_sangre],
    //       medio_promocion: [resultado.data.datos_adicionales.medio_promocion],
    //       factor_rh: [resultado.data.datos_adicionales.factor_rh],
    //       alergias: [resultado.data.datos_adicionales.alergias],
    //       presenta_alergias: [resultado.data.datos_adicionales.presenta_alergias],
    //       contacto_medico: [resultado.data.datos_adicionales.contacto_medico],
    //       telefono_medico: [resultado.data.datos_adicionales.telefono_medico],
    //       telefono_medico2: [resultado.data.datos_adicionales.telefono_medico2],
    //       padecimientos: [resultado.data.datos_adicionales.padecimientos],
    //       observaciones: [resultado.data.datos_adicionales.observaciones]
    //     }),
    //     datos_tutores: this.fb.group({
    //       personas_id: [resultado.data.id],
    //       nombre: [this.datoTutor.nombre],
    //       parentesco: [this.datoTutor.parentesco],
    //       telefono: [this.datoTutor.telefono],
    //       email: [this.datoTutor.email],
    //       nombre_2: [this.datoTutor.nombre2],
    //       parentesco_2: [this.datoTutor.parentesco_2],
    //       telefono2: [this.datoTutor.telefono_2],
    //       email2: [this.datoTutor.email2],
    //       observaciones: [this.datoTutor.observaciones]
    //     }),
    //     preinscripciones_requisitos: this.fb.group(this.datoRequi)
    //   });


    // })
  }

  enviarDatos(regresar: boolean = true, reset_form: boolean = false) {
    if (this.tieneid) {
      this.actualizarPreinscripcion();
    } else {
      this.guardarPreinscripcion(regresar, reset_form);
    }
  }


  actualizarPreinscripcion() {
    this.cargando = true;
    let json = this.dato.getRawValue();
    this.crud.editar(this.tieneid, json, "preinscripcion").subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status == 200 || resultado.status == 201) {
          this.mensajeResponse.texto = 'Se han guardado los cambios."';
          this.mensajeResponse.mostrar = true;
          this.mensajeResponse.clase = "success";
          this.mensaje(2);
        } else {
          this.mensajeResponse.texto = 'No se guardado los cambios."';
          this.mensajeResponse.mostrar = true;
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
      },
      error => {
        this.cargando = false;

        this.mensajeResponse.texto = "No especificado.";
        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.clase = "alert";
        this.mensaje(2);
        try {
          let e = error.json();
          if (error.status == 401) {
            this.mensajeResponse.texto =
              "No tiene permiso para hacer esta operación.";
            this.mensajeResponse.clase = "error";
            this.mensaje(2);
          }
          //  Problema de validación
          if (error.status == 409) {
            this.mensajeResponse.texto =
              "Por favor verfique los campos marcados en rojo.";
            this.mensajeResponse.clase = "error";
            this.mensaje(8);
            for (let input in e.error) {
              //  Iteramos todos los errores
              for (let i in e.error[input]) {
                this.mensajeResponse.titulo = input;
                this.mensajeResponse.texto = e.error[input][i];
                this.mensajeResponse.clase = "error";
                this.mensaje(3);
              }
            }
          }
        } catch (e) {
          if (error.status == 500) {
            this.mensajeResponse.texto = "500 (Error interno del servidor)";
          } else {
            this.mensajeResponse.texto =
              "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir. 3";
          }
          this.mensajeResponse.clase = "error";
          this.mensaje(2);
        }
      }
    );
  }
  /**
   * Este método envia los datos para agregar un elemento
   * @return void
   */


  guardarPreinscripcion(regresar, reset_form) {
    this.cargando = true;
    this.guardado = false;
    let json = this.dato.getRawValue();
    this.crud.crear(json, "preinscripcion").subscribe(
      resultado => {
        this.guardado = true;
        this.cargando = false;
        if (resultado.status == 200 || resultado.status == 201) {
          // if (document.getElementById('despues_de_guardar'))
          //   document.getElementById('despues_de_guardar')?.click();
          this.quitar_elemento_cola();
          window.location.href = '#/' + this.url_editar + '' + resultado.data.id;
          if (reset_form) {
            this.reset_form();
          }

        }
        else {
          this.mensajeResponse.texto = 'No se guardado los cambios."';
          this.mensajeResponse.mostrar = true;
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
      },
      error => {
        this.cargando = false;
        this.guardado = false;
        this.mensajeResponse.texto = "No especificado.";
        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.clase = "error";
        this.mensaje(3);

        try {
          let e = error.json();
          if (error.status == 401) {
            this.mensajeResponse.texto =
              "No tiene permiso para hacer esta operación.";
          }
          //  Problema de validación
          if (error.status == 409) {
            this.mensajeResponse.texto =
              "Por favor verfique los campos marcados en rojo.";
            this.mensajeResponse.clase = "warning";
            this.mensaje(8);
            for (let input in e.error) {
              //  Iteramos todos los errores
              for (let i in e.error[input]) {
                this.mensajeResponse.titulo = input;
                this.mensajeResponse.texto = e.error[input][i];
                this.mensajeResponse.clase = "error";
                this.mensaje(3);
              }
            }
          }
        } catch (e) {
          if (error.status == 500) {
            this.mensajeResponse.texto = "500 (Error interno del servidor)";
          } else {
            this.mensajeResponse.texto =
              "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir. 2";
          }
        }
      }
    );
  }


  quitar_elemento_cola() {
    if (this.dato.controls.cola) {
      if (this[this.URL]) {
        this[this.URL].splice(this.dato.controls.cola.value, 1);
        localStorage.setItem(this.URL, JSON.stringify(this[this.URL]));
      }
    }
  }


  imprimir_fichaORIG() {

    moment.locale("es-mx");
    var creado_el = moment(this.creado).format('LL');
    var day = moment().format('DD');
    var month = moment().format('MMMM');
    var year = moment().format('YYYY');
    let doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: 'letter'
    });
    let width = doc.internal.pageSize.getWidth();
    let height = doc.internal.pageSize.getHeight();

    let linea_y = 10;
    let linea_x = 0

    let logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
    if (logo != "")
      doc.addImage(logo, "PNG", 10, 5, 20, 20, "", "FAST");

    let pais = '';
    let estado = '';
    let municipio = '';


    this.catalogosDinamicos[1].forEach(element => {
      pais = element.nombre;
      element.estados.forEach(estados => {
        if (this.dato.get('estado_nacimiento').value == estados.id) {
          estado = estados.nombre;
        }
      });
    });




    this.catalogosDinamicos[this.dato.get('estado_nacimiento').value].forEach(element => {
      if (this.dato.get('municipio_nacimiento').value == element.id) {
        municipio = element.nombre;
      }
    });

    let estado_m = '';
    let municipio_m = '';

    this.catalogosDinamicos[1].forEach(element => {
      element.estados.forEach(estados => {
        if (this.dato.get('datos_adicionales').get('domicilio_estado').value == estados.id) {
          estado_m = estados.nombre;
        }
      })
    });

    this.catalogosDinamicos[this.dato.get('datos_adicionales').get('domicilio_estado').value].forEach(element => {
      if (this.dato.get('datos_adicionales').get('domicilio_municipio').value == element.id) {
        municipio_m = element.nombre;
      }
    });
    let carrera = '';
    let modalidad = '';
    let grupo = '';

    this.carreras_general.forEach(element => {
      if (this.dato.get('carreras_id').value == element.carreras.id) {
        carrera = element.carreras.nombre;
      }
    });

    this.modalidades_general.forEach(element => {
      if (this.dato.get('modalidades_id').value == element.id) {
        modalidad = element.nombre_imprimir;
      }
    });

    this.grupos.forEach(element => {
      if (this.dato.get('grupos_id').value == element.id) {
        grupo = element.clave + ' ' + element.identificador
      }
    });

    let sexo = '';

    if (this.dato.controls.sexo.value == 'M') {
      sexo = 'MASCULINO';
    } else {
      sexo = 'FEMENINO';
    }

    let estado_civil = '';
    let idioma = '';
    let nee = '';

    this.estados_civiles.forEach(element => {
      if (this.dato.get('estado_civil_id').value == element.id) {
        estado_civil = element.descripcion;
      }
    });

    this.idiomas.forEach(element => {
      if (this.dato.get('idioma').value == element.id) {
        idioma = element.descripcion;
      }
    });

    this.necesidades_especiales.forEach(element => {
      if (this.dato.get('necesidad_educativa_especial').value == element.id) {
        nee = element.descripcion;
      }
    });

    let sector = '';

    if (this.dato.controls.datos_adicionales['controls'].sector_escuela_procedencia.value == 1) {
      sector = 'PÚBLICO';
    } else {
      sector = 'PRIVADO';
    }

    let tipo_promocion = '';
    this.tipos_promocion.forEach(element => {
      //medio_promocion
      if (this.dato.controls.datos_adicionales['controls'].medio_promocion.value == element.id) {
        tipo_promocion = element.descripcion
      }
    });

    let tipo_sangre = '';
    let factor_rh = '';

    this.tipos_de_sangre.forEach(element => {
      if (this.dato.controls.datos_adicionales['controls'].tipo_sangre.value == element.id) {
        tipo_sangre = element.descripcion;
      }
    });


    this.factor_rh.forEach(element => {
      if (this.dato.controls.datos_adicionales['controls'].factor_rh.value == element.id) {
        factor_rh = element.descripcion;
      }
    });

    let alergias = '';
    if (this.dato.controls.datos_adicionales['controls'].presenta_alergias.value == 1) {
      alergias = 'SI';
    } else {
      alergias = 'NO';
    }

    let parentesco = '';
    let parentesco2 = '';

    this.parentescos.forEach(element => {

      if (this.dato.controls.datos_tutores['controls'].parentesco.value) {
        if (this.dato.controls.datos_tutores['controls'].parentesco.value == element.id) {
          parentesco = element.descripcion;
        }
      }

      if (this.dato.controls.datos_tutores['controls'].parentesco_2.value) {
        if (this.dato.controls.datos_tutores['controls'].parentesco_2.value == element.id) {
          parentesco2 = element.descripcion;
        }
      }
    });

    let nombre_tutor = this.dato.controls.datos_tutores['controls'].nombre.value ? this.dato.controls.datos_tutores['controls'].nombre.value : '';
    let telefono_tutor = this.dato.controls.datos_tutores['controls'].telefono.value ? this.dato.controls.datos_tutores['controls'].telefono.value : '';
    let correo_tutor = this.dato.controls.datos_tutores['controls'].email.value ? this.dato.controls.datos_tutores['controls'].email.value : '';


    let nombre_tutor2 = this.dato.controls.datos_tutores['controls'].nombre_2.value ? this.dato.controls.datos_tutores['controls'].nombre_2.value : '';
    let telefono_tutor2 = this.dato.controls.datos_tutores['controls'].telefono2.value ? this.dato.controls.datos_tutores['controls'].telefono2.value : '';
    let correo_tutor2 = this.dato.controls.datos_tutores['controls'].email2.value ? this.dato.controls.datos_tutores['controls'].email2.value : '';

    let alergias_gnereral = this.dato.controls.datos_adicionales['controls'].alergias.value ? this.dato.controls.datos_adicionales['controls'].alergias.value : '';
    let padecimientos = this.dato.controls.datos_adicionales['controls'].padecimientos.value ? this.dato.controls.datos_adicionales['controls'].padecimientos.value : '';

    let contacto_med = this.dato.controls.datos_adicionales['controls'].contacto_medico.value ? this.dato.controls.datos_adicionales['controls'].contacto_medico.value : '';
    let telefono_med = this.dato.controls.datos_adicionales['controls'].telefono_medico.value ? this.dato.controls.datos_adicionales['controls'].telefono_medico.value : '';
    let telefono2_med = this.dato.controls.datos_adicionales['controls'].telefono_medico2.value ? this.dato.controls.datos_adicionales['controls'].telefono_medico2.value : '';
    doc.setFontSize(7);
    doc.setFont("helvetica", "bold");
    doc.text( 'FECHA: ' + creado_el.toUpperCase(),170,5, { align: 'left' });
    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
   
    //configuracion de encabezado
    doc.text(this.configuracion.empresa.nombre, width / 2, linea_y, { align: 'center' });
    doc.text('CAMPUS: ' + this.configuracion.sucursal.nombre.toUpperCase(), width / 2, linea_y + 4, { align: 'center' });

    doc.text('FICHA DE INSCRIPCIÓN', width / 2, linea_y + 12, { align: 'center' });
    doc.setTextColor(255, 0, 0);
    doc.setFontSize(10);
    doc.text('FOLIO: ', 170, linea_y + 12, { align: 'left' });
    doc.text(this.folio,185, linea_y + 12, { align: 'left' });
    doc.setFontSize(8);
    doc.setTextColor(0);
    doc.text('INFORMACIÓN ESCOLAR', width / 2, linea_y + 20, { align: 'center' });
    doc.text('DATOS DEL ALUMNO', width / 2, 52, { align: 'center' });
    doc.text('DATOS DE CONTACTO', width / 2, 92, { align: 'center' });
    doc.text('DOMICILIO DEL ALUMNO', width / 2, 108, { align: 'center' });
    doc.text('ANTECEDENTES ESCOLARES', width / 2, 136, { align: 'center' });
    doc.text('DATOS DEL TUTOR', width / 2, 158, { align: 'center' });
    doc.text('DATOS DE SALUD', width / 2, 198, { align: 'center' });

    doc.rect(10, 34, 28, 34);
    doc.text('Fotografía', 18, 52)
    doc.roundedRect(40, 32, 166, 16, 2, 2);
    doc.roundedRect(40, 54, 166, 16, 2, 2);
    doc.roundedRect(10, 72, 196, 16, 2, 2);
    doc.roundedRect(10, 94, 196, 10, 2, 2);
    doc.roundedRect(10, 110, 196, 22, 2, 2);
    doc.roundedRect(10, 138, 196, 16, 2, 2);
    doc.roundedRect(10, 160, 196, 16, 2, 2);
    doc.roundedRect(10, 178, 196, 16, 2, 2);
    doc.roundedRect(10, 200, 196, 28, 2, 2);
    doc.roundedRect(10, 230, 196, 16, 2, 2);


    doc.setFontSize(6);
    doc.setFont("helvetica", "bold");
    //informacion escolar
    doc.text('CARRERA: ', 44, 38, { align: 'left' });
    doc.text('MODALIDAD: ', 44, 44, { align: 'left' });
    doc.text('GRUPO: ', 127, 44, { align: 'left' });
    doc.setFont("helvetica", "normal");
    doc.text(carrera, 57, 38, { align: 'left' });
    doc.text(modalidad, 60, 44, { align: 'left' });
    doc.text(grupo, 137, 44, { align: 'left' });
    //datos del alumno
    doc.setFont("helvetica", "bold");

    doc.text('APELLIDO PATERNO: ', 44, 60, { align: 'left' });
    doc.text('APELLIDO MATERNO: ', 98, 60, { align: 'left' });
    doc.text('NOMBRE(S): ', 152, 60, { align: 'left' });
    doc.text('CURP: ', 44, 66, { align: 'left' });
    doc.text('FECHA DE NACIMIENTO: ', 98, 66, { align: 'left' });
    doc.text('SEXO: ', 152, 66, { align: 'left' });
    doc.text('PAÍS DE NACIMIENTO: ', 14, 78, { align: 'left' });
    doc.text('EDO. DE NACIMIENTO: ', 80, 78, { align: 'left' });
    doc.text('MUNI. DE NACIMIENTO: ', 146, 78, { align: 'left' });
    doc.text('ESTADO CIVIL: ', 14, 84, { align: 'left' });
    doc.text('IDIOMA: ', 80, 84, { align: 'left' });
    doc.text('NEE: ', 146, 84, { align: 'left' });
    doc.setFont("helvetica", "normal");
    doc.text(this.dato.controls.apellido_paterno.value.toUpperCase(), 67, 60, { align: 'left' });
    doc.text(this.dato.controls.apellido_materno.value.toUpperCase(), 122, 60, { align: 'left' });
    doc.text(this.dato.controls.nombre.value.toUpperCase(), 166, 60, { align: 'left' });
    doc.text(this.dato.controls.curp.value.toUpperCase(), 52, 66, { align: 'left' });
    doc.text(this.dato.controls.fecha_nacimiento.value, 125, 66, { align: 'left' });
    doc.text(sexo, 160, 66, { align: 'left' });
    doc.text(pais.toUpperCase(), 40, 78, { align: 'left' });
    doc.text(estado.toUpperCase(), 104, 78, { align: 'left' });
    doc.text(municipio.toUpperCase(), 172, 78, { align: 'left' });
    doc.text(estado_civil.toUpperCase(), 31, 84, { align: 'left' });
    doc.text(idioma.toUpperCase(), 90, 84, { align: 'left' });
    doc.text(nee.toUpperCase(), 152, 84, { align: 'left' });
    //datos de contacto
    doc.setFont("helvetica", "bold");
    doc.text('CORREO: ', 14, 100, { align: 'left' });
    doc.text('TELÉFONO: ', 80, 100, { align: 'left' });
    doc.text('TELÉFONO 2: ', 146, 100, { align: 'left' });
    doc.setFont("helvetica", "normal");
    doc.text(this.dato.controls.email.value.toUpperCase(), 25, 100, { align: 'left' });
    doc.text(this.dato.controls.telefono.value.toUpperCase(), 94, 100, { align: 'left' });
    doc.text(this.dato.controls.telefono2.value.toUpperCase(), 161, 100, { align: 'left' });

    //
    doc.setFont("helvetica", "bold");
    doc.text('ESTADO: ', 14, 116, { align: 'left' });
    doc.text('MUNICIPIO: ', 80, 116, { align: 'left' });
    doc.text('COLONIA: ', 146, 116, { align: 'left' });
    doc.text('CALLE: ', 14, 122, { align: 'left' });
    doc.text('N° EXT.: ', 146, 122, { align: 'left' });
    doc.text('N° INT: ', 176, 122, { align: 'left' });
    doc.text('REFERENCIAS: ', 14, 128, { align: 'left' });
    doc.setFont("helvetica", "normal");
    doc.text(estado_m.toUpperCase(), 25, 116, { align: 'left' });
    doc.text(municipio_m.toUpperCase(), 94, 116, { align: 'left' });
    doc.text(this.dato.get('datos_adicionales').get('domicilio_colonia').value.toUpperCase(), 158, 116, { align: 'left' });
    doc.text(this.dato.get('datos_adicionales').get('domicilio_calle').value.toUpperCase(), 23, 122, { align: 'left' });
    doc.text(this.dato.get('datos_adicionales').get('domicilio_exterior').value, 156, 122, { align: 'left' });
    doc.text(this.dato.get('datos_adicionales').get('domicilio_interior').value.toString(), 184, 122, { align: 'left' });
    doc.text(this.dato.get('datos_adicionales').get('domicilio_referencias').value.toUpperCase(), 31, 128, { align: 'left' });
    //
    doc.setFont("helvetica", "bold");
    doc.text('INSTITUCIÓN DE PROCEDENCIA: ', 14, 144, { align: 'left' });
    doc.text('SECTOR: ', 146, 144, { align: 'left' });
    doc.text('MEDIO DE PROMOCIÓN: ', 14, 150, { align: 'left' });
    doc.setFont("helvetica", "normal");
    doc.text(this.dato.controls.datos_adicionales['controls'].escuela_procedencia.value.toUpperCase(), 50, 144, { align: 'left' });
    doc.text(sector, 158, 144, { align: 'left' });
    doc.text(tipo_promocion.toUpperCase(), 40, 150, { align: 'left' });
    //

    doc.setFont("helvetica", "bold");
    doc.text('NOMBRE: ', 14, 166, { align: 'left' });
    doc.text('PARENTESCO: ', 127, 166, { align: 'left' });
    doc.text('TELÉFONO: ', 14, 172, { align: 'left' });
    doc.text('CORREO: ', 127, 172, { align: 'left' });
    doc.text('NOMBRE: ', 14, 184, { align: 'left' });
    doc.text('PARENTESCO: ', 127, 184, { align: 'left' });
    doc.text('TELÉFONO: ', 14, 190, { align: 'left' });
    doc.text('CORREO: ', 127, 190, { align: 'left' });
    doc.setFont("helvetica", "normal");
    doc.text(nombre_tutor.toUpperCase(), 25, 166, { align: 'left' });
    doc.text(parentesco.toUpperCase(), 144, 166, { align: 'left' });
    doc.text(telefono_tutor.toString(), 27, 172, { align: 'left' });
    doc.text(correo_tutor.toUpperCase(), 138, 172, { align: 'left' });

    doc.text(nombre_tutor2.toUpperCase(), 25, 184, { align: 'left' });
    doc.text(parentesco2.toUpperCase(), 144, 184, { align: 'left' });
    doc.text(telefono_tutor2.toString(), 27, 190, { align: 'left' });
    doc.text(correo_tutor2.toUpperCase(), 138, 190, { align: 'left' });

    doc.setFont("helvetica", "bold");
    doc.text('TIPO DE SANGRE: ', 14, 206, { align: 'left' });
    doc.text('FACTOR RH: ', 80, 206, { align: 'left' });
    doc.text('ALERGIAS: ', 146, 206, { align: 'left' });
    doc.text('ALERGIAS QUE PADECE: ', 14, 212, { align: 'left' });
    doc.text('PADECIMIENTOS: ', 14, 218, { align: 'left' });
    doc.text('CONTACTO MÉDICO: ', 14, 236, { align: 'left' });
    doc.text('TELÉFONO MÉDICO: ', 14, 242, { align: 'left' });
    doc.text('TELÉFONO MÉDICO 2: ', 80, 242, { align: 'left' });

    doc.setFont("helvetica", "normal");
    doc.text(tipo_sangre, 34, 206, { align: 'left' });
    doc.text(factor_rh, 95, 206, { align: 'left' });
    doc.text(alergias, 159, 206, { align: 'left' });
    doc.text(alergias_gnereral.toUpperCase(), 42, 212, { align: 'left' });
    doc.text(padecimientos.toUpperCase(), 34, 218, { align: 'left' });
    doc.text(contacto_med.toUpperCase(), 38, 236, { align: 'left' });
    doc.text(telefono_med.toUpperCase(), 38, 242, { align: 'left' });
    doc.text(telefono2_med.toUpperCase(), 104, 242, { align: 'left' });

    //
    doc.setFont("helvetica", "bold");
    doc.text(this.configuracion.sucursal.direccion, width/2, 262, {align:'center'});

    // doc.text('4A. Oriente Norte \n entre 12 y 13 Norte No.1352 \n Barrio La Pimienta \n CP.29034', 35, 260, { align: 'center' });
    // doc.text('contactoicsmish@gmail.com', 95, 262, { align: 'center' });
    // doc.text('961 125 62 27', 145, 262, { align: 'center' });
    // doc.text('www.icsmish.edu.mx', 195, 262, { align: 'center' });
    doc.setFillColor(0, 41, 98);
    doc.rect(5, 270, 206, 3, 'F');
    doc.setFillColor(176, 190, 197);
    doc.rect(5, 273, 206, 3, 'F');

    doc.addPage();
    if (logo != "")
      doc.addImage(logo, "PNG", 10, 5, 20, 20, "", "FAST");


    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
    //configuracion de encabezado
    doc.text(this.configuracion.empresa.nombre, width / 2, linea_y, { align: 'center' });
    doc.text('"UNIVERSIDAD DE PUEBLA"', width / 2, linea_y + 4, { align: 'center' });
    doc.text('documentación'.toUpperCase(), width / 2, linea_y + 20, { align: 'center' });
    // doc.text('Inscripción condicionada'.toUpperCase(), width / 2, linea_y + 20, { align: 'center' });
    // doc.text('colegiaturas y becas'.toUpperCase(), width / 2, 84, { align: 'center' });


    doc.setFontSize(6);
    doc.setFont("helvetica", "bold");

    doc.roundedRect(10, 32, 196, 28, 2, 2);



    for (let index = 0; index < this.requisito.length; index++) {

      const form = this.requisito[index];

      for (let j = 0; j < form.formularios_requisitos.length; j++) {
        const element = form.formularios_requisitos[j];
        for (let k = 0; k < element.length; k++) {
          const documento = element[k];
          if (documento.orden <= 3) {
            doc.text(documento.nombre.toUpperCase(), 14 + (k * 65), 38, { align: 'left', maxWidth: 35 });
            doc.rect(49 + (k * 65), 34.5, 4, 4);

            if (this.dato.controls.preinscripciones_requisitos['controls'][documento.id].value == 1) {
              doc.text('X', 50.5 + (k * 65), 37.5, { align: 'left', maxWidth: 35 });
            } else {
              doc.text('', 50.5 + (k * 65), 37.5, { align: 'left', maxWidth: 35 });
            }
          } else if (documento.orden > 3 && documento.orden <= 6) {
            doc.text(documento.nombre.toUpperCase(), 14 + (k * 65), 46, { align: 'left', maxWidth: 35 });
            doc.rect(49 + (k * 65), 43, 4, 4);
            if (this.dato.controls.preinscripciones_requisitos['controls'][documento.id].value == 1) {
              doc.text('X', 50.5 + (k * 65), 46, { align: 'left', maxWidth: 35 });
            } else {
              doc.text('', 50.5 + (k * 65), 46, { align: 'left', maxWidth: 35 });
            }
          } else {
            doc.text(documento.nombre.toUpperCase(), 14 + (k * 65), 54, { align: 'left', maxWidth: 35 });
            doc.rect(49 + (k * 65), 51, 4, 4);
            if (this.dato.controls.preinscripciones_requisitos['controls'][documento.id].value == 1) {
              doc.text('X', 50.5 + (k * 65), 54, { align: 'left', maxWidth: 35 });
            } else {
              doc.text('', 50.5 + (k * 65), 54, { align: 'left', maxWidth: 35 });
            }
          }
        }

      }

    }
    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
    let nombre_completo = this.dato.controls.nombre.value + ' ' + this.dato.controls.apellido_paterno.value + ' ' + this.dato.controls.apellido_materno.value;
    if (this.dato.controls.inscripcion_condicionada.value == 0) {
      let texto_x = 0;
      if (this.dato.controls.condicion_adicional.value == 1) {
        doc.roundedRect(10, 64, 196, 18, 2, 2);
        doc.text('Acepta los lineamientos institucionales sobre los documentos que debera presentar en originales en los tiempos que la institución le indique, para la realización de los trámites correspondientes a titulación, de no cumplir con estos requisitos y tiempos acepta las responsabilidades que deriven por dicho incumplimiento', 18, 70, { align: 'justify', maxWidth: 180 })
        texto_x += 86
      } else {
        texto_x += 64
      }

      //texto_x += 64
      doc.text('colegiaturas y becas'.toUpperCase(), width / 2, texto_x, { align: 'center' });

      texto_x += 2;
      let elem = document.getElementById("beca");
      let res = (doc as any).autoTableHtmlToJson(elem);
      (doc as any).autoTable(res.columns, res.data, {
        createdHeaderCell: function (cell, data) {
          cell.styles.halign = "left";
        },
        tableWidth: 187,
        startY: texto_x,
        headStyles: {
          halign: 'center',
          fontSize: 7,
          fillColor: [176, 190, 197],
          textColor: "#000000",

        },

        bodyStyles: {
          fontSize: 7,
          fillColor: "#FFFFFF",
          textColor: "#000000"
        },
        theme: "grid",
        columnStyles: {
          0: { cellWidth: 85 }
        }
      });
      //doc.roundedRect(10, 58, 196, 46, 2, 2);
    } else {
      doc.text('Inscripción condicionada'.toUpperCase(), width / 2, 64, { align: 'center' });
      doc.roundedRect(10, 66, 196, 40, 2, 2);
      doc.setFont("helvetica", "normal");
      doc.text('Quien suscribe', 18, 72, { align: 'left' });
      doc.text('interesado(a) en estudiar en esta institución para el', 119, 72, { align: 'left' });
      doc.text('periodo', 18, 78, { align: 'left' });
      doc.text(',acepto mi inscripción condicionada para ingresar al programa, teniendo en cuenta que debo', 84, 78, { align: 'left' });
      doc.text('entregar para el día', 18, 84, { align: 'left' });
      doc.text('la documentación pendiente.', 62, 84, { align: 'left' });

      doc.setFont("helvetica", "bold");
      doc.text(nombre_completo.toUpperCase(), 78.5, 72, { align: 'center' });
      doc.text(this.periodos_escolares, 56.25, 78, { align: 'center' });
      doc.text(this.dato.controls.fecha_condicionada.value, 44, 84, { align: 'left' });
      doc.setTextColor(177, 151, 80);
      doc.text('*En caso contrario estoy sabedor de que causaré baja temporal, hasta regularizarme con los documentos que me solicita la institución, Por lo que asumo la responsabilidad total al no egresar en tiempo y forma del ciclo escolar al que se me dio la oportunidad de ingresar, eximiendo de toda responsabilidad al'
        + ' ' + this.configuracion.empresa.nombre + ' "UNIVERSIDAD DE PUEBLA" ', 18, 92, { align: 'justify', maxWidth: 180 });
      doc.setTextColor(0);
      let texto_x = 0;
      if (this.dato.controls.condicion_adicional.value == 1) {
        doc.roundedRect(10, 110, 196, 18, 2, 2);
        doc.text('Acepta los lineamientos institucionales sobre los documentos que debera presentar en originales en los tiempos que la institución le indique, para la realización de los trámites correspondientes a titulación, de no cumplir con estos requisitos y tiempos acepta las responsabilidades que deriven por dicho incumplimiento', 18, 116, { align: 'justify', maxWidth: 180 })
        texto_x += 132
      } else {
        texto_x += 110
      }
      doc.text('colegiaturas y becas'.toUpperCase(), width / 2, texto_x, { align: 'center' });
      texto_x += 2;
      let elem = document.getElementById("beca");
      let res = (doc as any).autoTableHtmlToJson(elem);
      (doc as any).autoTable(res.columns, res.data, {
        createdHeaderCell: function (cell, data) {
          cell.styles.halign = "left";
        },
        tableWidth: 187,
        startY: texto_x,
        headStyles: {
          halign: 'center',
          fontSize: 7,
          fillColor: [176, 190, 197],
          textColor: "#000000",

        },

        bodyStyles: {
          fontSize: 7,
          fillColor: "#FFFFFF",
          textColor: "#000000"
        },
        theme: "grid",
        columnStyles: {
          0: { cellWidth: 85 }
        }
      });

    }

    doc.setFontSize(6);
    doc.setDrawColor(0);

    doc.roundedRect(10, doc.lastAutoTable.finalY + 4, 196, 26, 2, 2);
    let obs = this.dato.get('datos_adicionales').get('observaciones').value ? this.dato.get('datos_adicionales').get('observaciones').value : '';
    doc.text('OBSERVACIONES: ', 14, doc.lastAutoTable.finalY + 8, { align: 'left' });
    doc.setFont("helvetica", "normal");
    doc.text(obs.toUpperCase(), 35, doc.lastAutoTable.finalY + 8, { align: 'left' });
    doc.setFont("helvetica", "bold");
    doc.line(35, 240, 80, 240);
    doc.text(nombre_completo.toUpperCase(), 57.5, 243, { align: 'center', maxWidth: 45 });
    doc.line(145, 240, 190, 240);
    doc.text(this.usuario.nombre.toUpperCase(), 167.5, 243, { align: 'center', maxWidth: 45 });

    doc.text(this.configuracion.sucursal.direccion, width/2, 262, {align:'center'});

    // doc.text('4A. Oriente Norte \n entre 12 y 13 Norte No.1352 \n Barrio La Pimienta \n CP.29034', 35, 260, { align: 'center' });
    // doc.text('contactoicsmish@gmail.com', 95, 262, { align: 'center' });
    // doc.text('961 125 62 27', 145, 262, { align: 'center' });
    // doc.text('www.icsmish.edu.mx', 195, 262, { align: 'center' });
    doc.setFillColor(0, 41, 98);
    doc.rect(5, 270, 206, 3, 'F');
    doc.setFillColor(176, 190, 197);
    doc.rect(5, 273, 206, 3, 'F');

    window.open(doc.output('bloburl'), '_blank');


  }


    imprimir_ficha() {
  
      moment.locale("es-mx");
      var creado_el = moment(this.creado).format('LL');
      var day = moment().format('DD');
      var month = moment().format('MMMM');
      var year = moment().format('YYYY');
      let doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'letter'
      });
      let width = doc.internal.pageSize.getWidth();
      let height = doc.internal.pageSize.getHeight();
  
      let linea_y = 10;
      let linea_x = 0
  
      let logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
      if (logo != "")
        doc.addImage(logo, "PNG", 10, 5, 20, 20, "", "FAST");
  
      let pais = '';
      let estado = '';
      let municipio = '';
  
  /*
      this.catalogosDinamicos[1].forEach(element => {
        pais = element.nombre;
        element.estados.forEach(estados => {
          if (this.dato.get('estado_nacimiento').value == estados.id) {
            estado = estados.nombre;
          }
        });
      }); */
  
  /*
      this.catalogosDinamicos[this.dato.get('estado_nacimiento').value].forEach(element => {
        if (this.dato.get('municipio_nacimiento').value == element.id) {
          municipio = element.nombre;
        }
      });*/
  
      let estado_m = '';
      let municipio_m = '';

      let estado_domicilio_label    = '';
      let municipio_domicilio_label = '';




    this.catalogosDinamicos[1].forEach(element => {
      if (this.dato.get('datos_adicionales').get('domicilio_estado').value == element.id) {
        estado_domicilio_label = element.nombre;
      }
/*
      element.estados.forEach(estados => {
        if (this.dato.get('datos_adicionales').get('domicilio_estado').value == estados.id) {
          estado_m = estados.nombre;
        }
      })*/
    });

    this.catalogosDinamicos[this.dato.get('datos_adicionales').get('domicilio_estado').value].forEach(element => {
      if (this.dato.get('datos_adicionales').get('domicilio_municipio').value == element.id) {
        municipio_domicilio_label = element.nombre;

      }
    });
  
      /*
      this.catalogosDinamicos[1].forEach(element => {
        element.estados.forEach(estados => {
          if (this.dato.get('datos_adicionales').get('domicilio_estado').value == estados.id) {
            estado_domicilio_label = estados.nombre;
          }
        })
      });
  
      this.catalogosDinamicos[this.dato.get('datos_adicionales').get('domicilio_estado').value].forEach(element => {
        if (this.dato.get('datos_adicionales').get('domicilio_municipio').value == element.id) {
          municipio_domicilio_label = element.nombre;
        }
      });
      */
  
 /*
      this.estados.forEach(element => {
        console.log('>>>>>>>>>>>>     >>>>>>>>>>>>    ESTADO : '+element.nombre);
        if (this.dato.get('datos_adicionales').get('domicilio_estado').value == element.id) {
      estado_m = element.nombre;
      console.log('>>>>>>>>>>>>     >>>>>>>>>>>>    >>>>>>>>>>>>'+estado_m);
        }
      });
   
  
       this.municipios.forEach(element => {
        if (this.dato.get('datos_adicionales').get('domicilio_municipio').value == element.id) {
      municipio_m = element.nombre;
      console.log('>>>>>>>>>>>>     >>>>>>>>>>>>    >>>>>>>>>>>>'+municipio_m);
        }
      });
      */

      console.log('>>>>>>>>>>>>     >>>>>>>>>>>>    ESTADO DOMICILIO :');
      console.log('>>>>>>>>>>>>     >>>>>>>>>>>>    '+this.dato.get('datos_adicionales').get('domicilio_estado').value);
      console.log('>>>>>>>>>>>>     >>>>>>>>>>>>    MUNICIPIO DOMICILIO :');
      console.log('>>>>>>>>>>>>     >>>>>>>>>>>>    '+this.dato.get('datos_adicionales').get('domicilio_municipio').value);
  
  
      let carrera = '';
      let modalidad = '';
      let grupo = '';

     
  
      this.carreras_general.forEach(element => {
        if (this.dato.get('carreras_id').value == element.carreras.id) {
          carrera = element.carreras.nombre;
        }
      });
  
      this.modalidades_general.forEach(element => {
        if (this.dato.get('modalidades_id').value == element.id) {
          modalidad = element.nombre_imprimir;
        }
      });
  
      this.grupos.forEach(element => {
        if (this.dato.get('grupos_id').value == element.id) {
          grupo = element.clave + ' ' + element.identificador
        }
      });
  
      let sexo = '';
  
      if (this.dato.controls.sexo.value == 'M') {
        sexo = 'MASCULINO';
      } else {
        sexo = 'FEMENINO';
      }
  
      let pais_nacimiento_label   = '';
      let estado_nacimiento_label = '';
      let pais_procedencia_label  = '';
  
      let estado_civil = '';
      let idioma = '';
      let nee = '';
  
      this.estados_civiles.forEach(element => {
        if (this.dato.get('estado_civil_id').value == element.id) {
          estado_civil = element.descripcion;
        }
      });
  
      this.paises_nacimiento.forEach(element => {
        if (this.dato.get('pais_nacimiento').value == element.id) {
          //estado_civil = element.nombre;
          pais_nacimiento_label  = element.nombre;
        }
      });
  
      this.estados_nacimiento.forEach(element => {
        if (this.dato.get('estado_nacimiento').value == element.id) {
          //estado_civil = element.nombre;
          estado_nacimiento_label  = element.nombre;
        }
      });
  
      this.paises_nacimiento.forEach(element => {

        if (this.dato.get('pais_procedencia').value == element.id) {
          //estado_civil = element.nombre;
          pais_procedencia_label  = element.nombre;
        }
      }); 
  
  
      this.idiomas.forEach(element => {
        if (this.dato.get('idioma').value == element.id) {
          idioma = element.descripcion;
        }
      });
  
      this.necesidades_especiales.forEach(element => {
        if (this.dato.get('necesidad_educativa_especial').value == element.id) {
          nee = element.descripcion;
        }
      });
  
      let sector = '';
  
      if (this.dato.controls.datos_adicionales['controls'].sector_escuela_procedencia.value == 1) {
        sector = 'PÚBLICO';
      } else {
        sector = 'PRIVADO';
      }
  
      let tipo_promocion = '';
      this.tipos_promocion.forEach(element => {
        //medio_promocion
        if (this.dato.controls.datos_adicionales['controls'].medio_promocion.value == element.id) {
          tipo_promocion = element.descripcion
        }
      });
  
      let tipo_sangre = '';
      let factor_rh = '';
  
      this.tipos_de_sangre.forEach(element => {
        if (this.dato.controls.datos_adicionales['controls'].tipo_sangre.value == element.id) {
          tipo_sangre = element.descripcion;
        }
      });
  
  
      this.factor_rh.forEach(element => {
        if (this.dato.controls.datos_adicionales['controls'].factor_rh.value == element.id) {
          factor_rh = element.descripcion;
        }
      });
  
      let alergias = '';
      if (this.dato.controls.datos_adicionales['controls'].presenta_alergias.value == 1) {
        alergias = 'SI';
      } else {
        alergias = 'NO';
      }
  
      let parentesco = '';
      let parentesco2 = '';
  
      this.parentescos.forEach(element => {
  
        if (this.dato.controls.datos_tutores['controls'].parentesco.value) {
          if (this.dato.controls.datos_tutores['controls'].parentesco.value == element.id) {
            parentesco = element.descripcion;
          }
        }
  
        if (this.dato.controls.datos_tutores['controls'].parentesco_2.value) {
          if (this.dato.controls.datos_tutores['controls'].parentesco_2.value == element.id) {
            parentesco2 = element.descripcion;
          }
        }
      });
  
      let nombre_tutor = this.dato.controls.datos_tutores['controls'].nombre.value ? this.dato.controls.datos_tutores['controls'].nombre.value : '';
      let telefono_tutor = this.dato.controls.datos_tutores['controls'].telefono.value ? this.dato.controls.datos_tutores['controls'].telefono.value : '';
      let correo_tutor = this.dato.controls.datos_tutores['controls'].email.value ? this.dato.controls.datos_tutores['controls'].email.value : '';
  
  
      let nombre_tutor2 = this.dato.controls.datos_tutores['controls'].nombre_2.value ? this.dato.controls.datos_tutores['controls'].nombre_2.value : '';
      let telefono_tutor2 = this.dato.controls.datos_tutores['controls'].telefono2.value ? this.dato.controls.datos_tutores['controls'].telefono2.value : '';
      let correo_tutor2 = this.dato.controls.datos_tutores['controls'].email2.value ? this.dato.controls.datos_tutores['controls'].email2.value : '';
  
      let alergias_gnereral = this.dato.controls.datos_adicionales['controls'].alergias.value ? this.dato.controls.datos_adicionales['controls'].alergias.value : '';
      let padecimientos = this.dato.controls.datos_adicionales['controls'].padecimientos.value ? this.dato.controls.datos_adicionales['controls'].padecimientos.value : '';
  
      let contacto_med = this.dato.controls.datos_adicionales['controls'].contacto_medico.value ? this.dato.controls.datos_adicionales['controls'].contacto_medico.value : '';
      let telefono_med = this.dato.controls.datos_adicionales['controls'].telefono_medico.value ? this.dato.controls.datos_adicionales['controls'].telefono_medico.value : '';
      let telefono2_med = this.dato.controls.datos_adicionales['controls'].telefono_medico2.value ? this.dato.controls.datos_adicionales['controls'].telefono_medico2.value : '';
      doc.setFontSize(7);
      doc.setFont("helvetica", "bold");
      doc.text( 'FECHA: ' + creado_el.toUpperCase(),170,5, { align: 'left' });
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
     
      //configuracion de encabezado
      doc.text(this.configuracion.empresa.nombre, width / 2, linea_y, { align: 'center' });
      //doc.text('"CUM"', width / 2, linea_y + 4, { align: 'center' });
      doc.text(this.configuracion.empresa.subnombre, width / 2, linea_y + 4, { align: 'center' });
      doc.text('CAMPUS '+this.configuracion.sucursal.nombre.toUpperCase(), width / 2, linea_y + 8, { align: 'center' });
  
      doc.text('FICHA DE INSCRIPCIÓN', width / 2, linea_y + 12, { align: 'center' });
      doc.setTextColor(255, 0, 0);
      doc.setFontSize(10);
      doc.text('FOLIO: ', 170, linea_y + 12, { align: 'left' });
      doc.text(this.folio,185, linea_y + 12, { align: 'left' });
      doc.setFontSize(8);
      doc.setTextColor(0);
      doc.text('INFORMACIÓN ESCOLAR', width / 2, linea_y + 20, { align: 'center' });
      doc.text('DATOS DEL ALUMNO', width / 2, 52, { align: 'center' });
      doc.text('DATOS DE CONTACTO', width / 2, 92, { align: 'center' });
      doc.text('DOMICILIO DEL ALUMNO', width / 2, 108, { align: 'center' });
      doc.text('ANTECEDENTES ESCOLARES', width / 2, 136, { align: 'center' });
      doc.text('DATOS DEL TUTOR', width / 2, 158, { align: 'center' });
      doc.text('DATOS DE SALUD', width / 2, 198, { align: 'center' });
  
      doc.rect(10, 34, 28, 34);
      doc.text('Fotografía', 18, 52)
      doc.roundedRect(40, 32, 166, 16, 2, 2);
      doc.roundedRect(40, 54, 166, 16, 2, 2);
      doc.roundedRect(10, 72, 196, 16, 2, 2);
      doc.roundedRect(10, 94, 196, 10, 2, 2);
      doc.roundedRect(10, 110, 196, 22, 2, 2);
      doc.roundedRect(10, 138, 196, 16, 2, 2);
      doc.roundedRect(10, 160, 196, 16, 2, 2);
      doc.roundedRect(10, 178, 196, 16, 2, 2);
      doc.roundedRect(10, 200, 196, 28, 2, 2);
      doc.roundedRect(10, 230, 196, 16, 2, 2);
  
  
      doc.setFontSize(6);
      doc.setFont("helvetica", "bold");
      //informacion escolar
      doc.text('CARRERA: ', 44, 38, { align: 'left' });
      doc.text('MODALIDAD: ', 44, 44, { align: 'left' });
      doc.text('GRUPO: ', 127, 44, { align: 'left' });

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);

      doc.text(carrera, 57, 38, { align: 'left' });
      doc.text(modalidad, 60, 44, { align: 'left' });
      doc.text(grupo, 137, 44, { align: 'left' });
      //datos del alumno
      doc.setFont("helvetica", "bold");
      doc.setFontSize(6);
  
      doc.text('APELLIDO PATERNO: ', 44, 60, { align: 'left' });
      doc.text('APELLIDO MATERNO: ', 98, 60, { align: 'left' });
      doc.text('NOMBRE(S): ', 152, 60, { align: 'left' });
      doc.text('CURP: ', 44, 66, { align: 'left' });
      doc.text('FECHA DE NACIMIENTO: ', 98, 66, { align: 'left' });
      doc.text('SEXO: ', 152, 66, { align: 'left' });
      doc.text('PAÍS DE NACIMIENTO: ', 14, 78, { align: 'left' });
      doc.text('EDO. DE NACIMIENTO: ', 80, 78, { align: 'left' });
      doc.text('PAIS DE PROCEDENCIA: ', 146, 78, { align: 'left' });
      doc.text('ESTADO CIVIL: ', 14, 84, { align: 'left' });
      doc.text('IDIOMA: ', 80, 84, { align: 'left' });
      doc.text('NEE: ', 146, 84, { align: 'left' });

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);

      doc.text(this.dato.controls.apellido_paterno.value.toUpperCase(), 67, 60, { align: 'left' });
      doc.text(this.dato.controls.apellido_materno.value.toUpperCase(), 122, 60, { align: 'left' });
      doc.text(this.dato.controls.nombre.value.toUpperCase(), 166, 60, { align: 'left' });
      doc.text(this.dato.controls.curp.value.toUpperCase(), 52, 66, { align: 'left' });
      doc.text(this.dato.controls.fecha_nacimiento.value, 125, 66, { align: 'left' });
      doc.text(sexo, 160, 66, { align: 'left' });
      doc.text(pais_nacimiento_label.toUpperCase(), 40, 78, { align: 'left' });
      doc.text(estado_nacimiento_label.toUpperCase(), 104, 78, { align: 'left' });
      doc.text(pais_procedencia_label.toUpperCase(), 172, 78, { align: 'left' });

      doc.text(estado_civil.toUpperCase(), 31, 84, { align: 'left' });
      doc.text(idioma.toUpperCase(), 90, 84, { align: 'left' });
      doc.text(nee.toUpperCase(), 152, 84, { align: 'left' });
      //datos de contacto
      doc.setFont("helvetica", "bold");
      doc.setFontSize(6);

      doc.text('CORREO: ', 14, 100, { align: 'left' });
      doc.text('TELÉFONO: ', 80, 100, { align: 'left' });
      doc.text('TELÉFONO 2: ', 146, 100, { align: 'left' });
      doc.setFont("helvetica", "normal");
      doc.text(this.dato.controls.email.value.toUpperCase(), 25, 100, { align: 'left' });
      doc.text(this.dato.controls.telefono.value.toUpperCase(), 94, 100, { align: 'left' });
      doc.text(this.dato.controls.telefono2.value.toUpperCase(), 161, 100, { align: 'left' });
  
      //
      doc.setFont("helvetica", "bold");
      doc.text('ESTADO: ', 14, 116, { align: 'left' });
      doc.text('MUNICIPIO: ', 80, 116, { align: 'left' });
      doc.text('COLONIA: ', 146, 116, { align: 'left' });
      doc.text('CALLE: ', 14, 122, { align: 'left' });
      doc.text('N° EXT.: ', 146, 122, { align: 'left' });
      doc.text('N° INT: ', 176, 122, { align: 'left' });
      doc.text('REFERENCIAS: ', 14, 128, { align: 'left' });
      doc.setFont("helvetica", "normal");
      doc.text(estado_domicilio_label.toUpperCase(), 25, 116, { align: 'left' });
      doc.text(municipio_domicilio_label.toUpperCase(), 94, 116, { align: 'left' });
      doc.text(this.dato.get('datos_adicionales').get('domicilio_colonia').value.toUpperCase(), 158, 116, { align: 'left' });
      doc.text(this.dato.get('datos_adicionales').get('domicilio_calle').value.toUpperCase(), 23, 122, { align: 'left' });
      doc.text(this.dato.get('datos_adicionales').get('domicilio_exterior').value, 156, 122, { align: 'left' });
      doc.text(this.dato.get('datos_adicionales').get('domicilio_interior').value.toString(), 184, 122, { align: 'left' });
      doc.text(this.dato.get('datos_adicionales').get('domicilio_referencias').value.toUpperCase(), 31, 128, { align: 'left' });
      //
      doc.setFont("helvetica", "bold");
      doc.text('INSTITUCIÓN DE PROCEDENCIA: ', 14, 144, { align: 'left' });
      doc.text('SECTOR: ', 146, 144, { align: 'left' });
      doc.text('MEDIO DE PROMOCIÓN: ', 14, 150, { align: 'left' });
      doc.setFont("helvetica", "normal");
      doc.text(this.dato.controls.datos_adicionales['controls'].escuela_procedencia.value.toUpperCase(), 50, 144, { align: 'left' });
      doc.text(sector, 158, 144, { align: 'left' });
      doc.text(tipo_promocion.toUpperCase(), 40, 150, { align: 'left' });
      //
  
      doc.setFont("helvetica", "bold");
      doc.text('NOMBRE: ', 14, 166, { align: 'left' });
      doc.text('PARENTESCO: ', 127, 166, { align: 'left' });
      doc.text('TELÉFONO: ', 14, 172, { align: 'left' });
      doc.text('CORREO: ', 127, 172, { align: 'left' });
      doc.text('NOMBRE: ', 14, 184, { align: 'left' });
      doc.text('PARENTESCO: ', 127, 184, { align: 'left' });
      doc.text('TELÉFONO: ', 14, 190, { align: 'left' });
      doc.text('CORREO: ', 127, 190, { align: 'left' });
      doc.setFont("helvetica", "normal");
      doc.text(nombre_tutor.toUpperCase(), 25, 166, { align: 'left' });
      doc.text(parentesco.toUpperCase(), 144, 166, { align: 'left' });
      doc.text(telefono_tutor.toString(), 27, 172, { align: 'left' });
      doc.text(correo_tutor.toUpperCase(), 138, 172, { align: 'left' });
  
      doc.text(nombre_tutor2.toUpperCase(), 25, 184, { align: 'left' });
      doc.text(parentesco2.toUpperCase(), 144, 184, { align: 'left' });
      doc.text(telefono_tutor2.toString(), 27, 190, { align: 'left' });
      doc.text(correo_tutor2.toUpperCase(), 138, 190, { align: 'left' });
  
      doc.setFont("helvetica", "bold");
      doc.text('TIPO DE SANGRE: ', 14, 206, { align: 'left' });
      doc.text('FACTOR RH: ', 80, 206, { align: 'left' });
      doc.text('ALERGIAS: ', 146, 206, { align: 'left' });
      doc.text('ALERGIAS QUE PADECE: ', 14, 212, { align: 'left' });
      doc.text('PADECIMIENTOS: ', 14, 218, { align: 'left' });
      doc.text('CONTACTO MÉDICO: ', 14, 236, { align: 'left' });
      doc.text('TELÉFONO MÉDICO: ', 14, 242, { align: 'left' });
      doc.text('TELÉFONO MÉDICO 2: ', 80, 242, { align: 'left' });
  
      doc.setFont("helvetica", "normal");
      doc.text(tipo_sangre, 34, 206, { align: 'left' });
      doc.text(factor_rh, 95, 206, { align: 'left' });
      doc.text(alergias, 159, 206, { align: 'left' });
      doc.text(alergias_gnereral.toUpperCase(), 42, 212, { align: 'left' });
      doc.text(padecimientos.toUpperCase(), 34, 218, { align: 'left' });
      doc.text(contacto_med.toUpperCase(), 38, 236, { align: 'left' });
      doc.text(telefono_med.toUpperCase(), 38, 242, { align: 'left' });
      doc.text(telefono2_med.toUpperCase(), 104, 242, { align: 'left' });
  
      //
      doc.setFont("helvetica", "bold");
     // doc.text('4A. Oriente Norte \n entre 12 y 13 Norte No.1352 \n Barrio La Pimienta \n CP.29034', 35, 260, { align: 'center' });
     // doc.text('promocionyadmisiones@icsmish.edu.mx', 95, 262, { align: 'center' });
     // doc.text('961 304 95 16', 145, 262, { align: 'center' });
      doc.text(''+this.configuracion.sucursal.direccion, 35, 262, { align: 'center' });
      doc.text('www.cum-jmg.edu.mx/', 195, 262, { align: 'center' });
      doc.setFillColor(245, 73, 39);
      doc.rect(5, 270, 206, 3, 'F');
      doc.setFillColor(40, 40, 40);
      doc.rect(5, 273, 206, 3, 'F');
  
      doc.addPage();
      if (logo != "")
        doc.addImage(logo, "PNG", 10, 5, 20, 20, "", "FAST");
  
  
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      //configuracion de encabezado
      doc.text(this.configuracion.empresa.nombre, width / 2, linea_y, { align: 'center' });

      doc.text(this.configuracion.empresa.subnombre, width / 2, linea_y + 4, { align: 'center' });
      doc.text('CAMPUS '+this.configuracion.sucursal.nombre.toUpperCase(), width / 2, linea_y + 8, { align: 'center' });

     // doc.text('"CUM"', width / 2, linea_y + 4, { align: 'center' });
      doc.text('documentación'.toUpperCase(), width / 2, linea_y + 20, { align: 'center' });
      // doc.text('Inscripción condicionada'.toUpperCase(), width / 2, linea_y + 20, { align: 'center' });
      // doc.text('colegiaturas y becas'.toUpperCase(), width / 2, 84, { align: 'center' });
  
  
      doc.setFontSize(6);
      doc.setFont("helvetica", "bold");
  
      doc.roundedRect(10, 32, 196, 28, 2, 2);
  
  
  
      for (let index = 0; index < this.requisito.length; index++) {
  
        const form = this.requisito[index];
  
        for (let j = 0; j < form.formularios_requisitos.length; j++) {
          const element = form.formularios_requisitos[j];
          for (let k = 0; k < element.length; k++) {
            const documento = element[k];
            if (documento.orden <= 3) {
              doc.text(documento.nombre.toUpperCase(), 14 + (k * 65), 38, { align: 'left', maxWidth: 35 });
              doc.rect(49 + (k * 65), 34.5, 4, 4);
  
              if (this.dato.controls.preinscripciones_requisitos['controls'][documento.id].value == 1) {
                doc.text('X', 50.5 + (k * 65), 37.5, { align: 'left', maxWidth: 35 });
              } else {
                doc.text('', 50.5 + (k * 65), 37.5, { align: 'left', maxWidth: 35 });
              }
            } else if (documento.orden > 3 && documento.orden <= 6) {
              doc.text(documento.nombre.toUpperCase(), 14 + (k * 65), 46, { align: 'left', maxWidth: 35 });
              doc.rect(49 + (k * 65), 43, 4, 4);
              if (this.dato.controls.preinscripciones_requisitos['controls'][documento.id].value == 1) {
                doc.text('X', 50.5 + (k * 65), 46, { align: 'left', maxWidth: 35 });
              } else {
                doc.text('', 50.5 + (k * 65), 46, { align: 'left', maxWidth: 35 });
              }
            } else {
              doc.text(documento.nombre.toUpperCase(), 14 + (k * 65), 54, { align: 'left', maxWidth: 35 });
              doc.rect(49 + (k * 65), 51, 4, 4);
              if (this.dato.controls.preinscripciones_requisitos['controls'][documento.id].value == 1) {
                doc.text('X', 50.5 + (k * 65), 54, { align: 'left', maxWidth: 35 });
              } else {
                doc.text('', 50.5 + (k * 65), 54, { align: 'left', maxWidth: 35 });
              }
            }
          }
  
        }
  
      }
      doc.setFontSize(8);
      doc.setFont("helvetica", "bold");
      let nombre_completo = this.dato.controls.nombre.value + ' ' + this.dato.controls.apellido_paterno.value + ' ' + this.dato.controls.apellido_materno.value;
      if (this.dato.controls.inscripcion_condicionada.value == 0) {
        let texto_x = 0;
        if (this.dato.controls.condicion_adicional.value == 1) {
          doc.roundedRect(10, 64, 196, 18, 2, 2);
          doc.text('Acepta los lineamientos institucionales sobre los documentos que debera presentar en originales en los tiempos que la institución le indique, para la realización de los trámites correspondientes a titulación, de no cumplir con estos requisitos y tiempos acepta las responsabilidades que deriven por dicho incumplimiento', 18, 70, { align: 'justify', maxWidth: 180 })
          texto_x += 86
        } else {
          texto_x += 64
        }
  
        //texto_x += 64
        doc.text('colegiaturas y becas'.toUpperCase(), width / 2, texto_x, { align: 'center' });
  
        texto_x += 2;
        let elem = document.getElementById("beca");
        let res = (doc as any).autoTableHtmlToJson(elem);
        (doc as any).autoTable(res.columns, res.data, {
          createdHeaderCell: function (cell, data) {
            cell.styles.halign = "left";
          },
          tableWidth: 187,
          startY: texto_x,
          headStyles: {
            halign: 'center',
            fontSize: 7,
            //fillColor: [202, 218, 205],
            fillColor: [176, 176, 176],
            textColor: "#000000",
  
          },
  
          bodyStyles: {
            fontSize: 7,
            fillColor: "#FFFFFF",
            textColor: "#000000"
          },
          theme: "grid",
          columnStyles: {
            0: { cellWidth: 85 }
          }
        });
        //doc.roundedRect(10, 58, 196, 46, 2, 2);
      } else {
        doc.text('Inscripción condicionada'.toUpperCase(), width / 2, 64, { align: 'center' });
        doc.roundedRect(10, 66, 196, 40, 2, 2);
        doc.setFont("helvetica", "normal");
        doc.text('Quien suscribe', 18, 72, { align: 'left' });
        doc.text('interesado(a) en estudiar en esta institución para el', 119, 72, { align: 'left' });
        doc.text('periodo', 18, 78, { align: 'left' });
        doc.text(',acepto mi inscripción condicionada para ingresar al programa, teniendo en cuenta que debo', 84, 78, { align: 'left' });
        doc.text('entregar para el día', 18, 84, { align: 'left' });
        doc.text('la documentación pendiente.', 62, 84, { align: 'left' });
  
        doc.setFont("helvetica", "bold");
        doc.text(nombre_completo.toUpperCase(), 78.5, 72, { align: 'center' });
        doc.text(this.periodos_escolares, 56.25, 78, { align: 'center' });
        doc.text(this.dato.controls.fecha_condicionada.value, 44, 84, { align: 'left' });
        doc.setTextColor(177, 151, 80);
        doc.text('*En caso contrario estoy sabedor de que causaré baja temporal, hasta regularizarme con los documentos que me solicita la institución, Por lo que asumo la responsabilidad total al no egresar en tiempo y forma del ciclo escolar al que se me dio la oportunidad de ingresar, eximiendo de toda responsabilidad al'
          + ' ' + this.configuracion.empresa.nombre + ' '+this.configuracion.empresa.subnombre, 18, 92, { align: 'justify', maxWidth: 180 });
        doc.setTextColor(0);
        let texto_x = 0;
        if (this.dato.controls.condicion_adicional.value == 1) {
          doc.roundedRect(10, 110, 196, 18, 2, 2);
          doc.text('Acepta los lineamientos institucionales sobre los documentos que debera presentar en originales en los tiempos que la institución le indique, para la realización de los trámites correspondientes a titulación, de no cumplir con estos requisitos y tiempos acepta las responsabilidades que deriven por dicho incumplimiento', 18, 116, { align: 'justify', maxWidth: 180 })
          texto_x += 132
        } else {
          texto_x += 110
        }
        doc.text('colegiaturas y becas'.toUpperCase(), width / 2, texto_x, { align: 'center' });
        texto_x += 2;
        let elem = document.getElementById("beca");
        let res = (doc as any).autoTableHtmlToJson(elem);
        (doc as any).autoTable(res.columns, res.data, {
          createdHeaderCell: function (cell, data) {
            cell.styles.halign = "left";
          },
          tableWidth: 187,
          startY: texto_x,
          headStyles: {
            halign: 'center',
            fontSize: 7,
           // fillColor: [202, 218, 205],
            fillColor: [176, 176, 176],
            textColor: "#000000",
  
          },
  
          bodyStyles: {
            fontSize: 7,
            fillColor: "#FFFFFF",
            textColor: "#000000"
          },
          theme: "grid",
          columnStyles: {
            0: { cellWidth: 85 }
          }
        });
  
      }
  
      doc.setFontSize(6);
      doc.setDrawColor(0);
  
      doc.roundedRect(10, doc.lastAutoTable.finalY + 4, 196, 26, 2, 2);
      let obs = this.dato.get('datos_adicionales').get('observaciones').value ? this.dato.get('datos_adicionales').get('observaciones').value : '';
      doc.text('OBSERVACIONES: ', 14, doc.lastAutoTable.finalY + 8, { align: 'left' });
      doc.setFont("helvetica", "normal");
      doc.text(obs.toUpperCase(), 35, doc.lastAutoTable.finalY + 8, { align: 'left' });
      doc.setFont("helvetica", "bold");
      doc.line(35, 240, 80, 240);
      doc.text(nombre_completo.toUpperCase(), 57.5, 243, { align: 'center', maxWidth: 45 });
      doc.line(145, 240, 190, 240);
      doc.text(this.usuario.nombre.toUpperCase(), 167.5, 243, { align: 'center', maxWidth: 45 });
  
      //doc.text('4A. Oriente Norte \n entre 12 y 13 Norte No.1352 \n Barrio La Pimienta \n CP.29034', 35, 260, { align: 'center' });
     // doc.text('promocionyadmisiones@icsmish.edu.mx', 95, 262, { align: 'center' });
      //doc.text('961 304 95 16', 145, 262, { align: 'center' });
      doc.text(''+this.configuracion.sucursal.direccion, 35, 262, { align: 'center' });
      doc.text('www.cum-jmg.edu.mx', 195, 262, { align: 'center' });
      doc.setFillColor(177, 151, 80);
          doc.setFillColor(245, 73, 39);
      doc.rect(5, 270, 206, 3, 'F');
      doc.setFillColor(67, 119, 61);
          doc.setFillColor(40, 40, 40);
      doc.rect(5, 273, 206, 3, 'F');
  
       
  
      window.open(doc.output('bloburl'), '_blank');
      //doc.save('REGISTRO' + variable_name + Date.now() + '.pdf');
/*
      const pdfBlob = doc.output('blob');
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'INSCRIPCION_' + this.folio+ '_' + Date.now() + '.pdf';
      link.click();
      URL.revokeObjectURL(url);

       try {
        const timestamp = Date.now();
        const nombreArchivo = `INSCRIPCION_${this.folio}${timestamp}.pdf`;
        
        // Opción recomendada
        //doc.save(nombreArchivo);
        
        // O si prefieres el método con Blob:
         const pdfBlob = doc.output('blob');
         const url = URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = nombreArchivo;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        
    } catch (error) {
        console.error('Error al descargar el PDF:', error);
    }*/

  
  
    }


  imprimir_limpio() {
    moment.locale("es-mx");
    var day = moment().format('DD');
    var month = moment().format('MMMM');
    var year = moment().format('YYYY');
    let doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: 'letter'
    });
    let width = doc.internal.pageSize.getWidth();
    let height = doc.internal.pageSize.getHeight();

    let linea_y = 10;          
    let linea_x = 0

    let logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
    if (logo != "")
      doc.addImage(logo, "PNG", 10, 5, 20, 20, "", "FAST");


    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");  
    //configuracion de encabezado
    doc.text(this.configuracion.empresa.nombre, width / 2, linea_y, { align: 'center' });

    doc.text(this.configuracion.empresa.subnombre, width / 2, linea_y + 4, { align: 'center' });
    doc.text('CAMPUS '+this.configuracion.sucursal.nombre.toUpperCase(), width / 2, linea_y + 8, { align: 'center' });

    //doc.text('"UNIVERSIDAD DE PUEBLA"', width / 2, linea_y + 4, { align: 'center' });

    doc.text('FICHA DE INSCRIPCIÓN', width / 2, linea_y + 12, { align: 'center' });
    doc.text('INFORMACIÓN ESCOLAR', width / 2, linea_y + 20, { align: 'center' });
    doc.text('DATOS DEL ALUMNO', width / 2, 52, { align: 'center' });
    doc.text('DATOS DE CONTACTO', width / 2, 92, { align: 'center' });
    doc.text('DOMICILIO DEL ALUMNO', width / 2, 108, { align: 'center' });
    doc.text('ANTECEDENTES ESCOLARES', width / 2, 136, { align: 'center' });
    doc.text('DATOS DEL TUTOR', width / 2, 158, { align: 'center' });
    doc.text('DATOS DE SALUD', width / 2, 198, { align: 'center' });

    doc.rect(10, 34, 28, 34);
    doc.text('Fotografía', 18, 52)
    doc.roundedRect(40, 32, 166, 16, 2, 2);
    doc.roundedRect(40, 54, 166, 16, 2, 2);
    doc.roundedRect(10, 72, 196, 16, 2, 2);
    doc.roundedRect(10, 94, 196, 10, 2, 2);
    doc.roundedRect(10, 110, 196, 22, 2, 2);
    doc.roundedRect(10, 138, 196, 16, 2, 2);
    doc.roundedRect(10, 160, 196, 16, 2, 2);
    doc.roundedRect(10, 178, 196, 16, 2, 2);
    doc.roundedRect(10, 200, 196, 28, 2, 2);
    doc.roundedRect(10, 230, 196, 16, 2, 2);


    doc.setFontSize(6);
    doc.setFont("helvetica", "bold");
    //informacion escolar
    doc.text('CARRERA: ', 44, 38, { align: 'left' });
    //doc.line(56, 39, 200, 39);
    doc.text('MODALIDAD: ', 44, 44, { align: 'left' });
    //doc.line(58.20, 45, 126, 45);
    doc.text('GRUPO: ', 127, 44, { align: 'left' });
    //doc.line(136.03, 45, 200, 45);
    doc.text('APELLIDO PATERNO: ', 44, 60, { align: 'left' });
    //doc.line(66.45, 61, 97, 61);
    doc.text('APELLIDO MATERNO: ', 98, 60, { align: 'left' });
    //doc.line(121, 61, 151, 61);
    doc.text('NOMBRE(S): ', 152, 60, { align: 'left' });
    //doc.line(165.46, 61, 200, 61);
    doc.text('CURP: ', 44, 66, { align: 'left' });
    //doc.line(51.26, 67, 97, 67);
    doc.text('FECHA DE NACIMIENTO: ', 98, 66, { align: 'left' });
    //doc.line(124, 67, 151, 67);

    doc.text('SEXO: ', 152, 66, { align: 'left' });
    //doc.line(159.13, 67, 200, 67);

    doc.text('PAÍS DE NACIMIENTO: ', 14, 78, { align: 'left' });
    //doc.line(37.47, 79, 77, 79);

    doc.text('EDO. DE NACIMIENTO: ', 80, 78, { align: 'left' });
    //doc.line(104, 79, 145, 79);
    doc.text('PAÍS. DE PROCEDENCIA: ', 146, 78, { align: 'left' });
    //doc.line(171, 79, 200, 79);
    doc.text('ESTADO CIVIL: ', 14, 84, { align: 'left' });
    //doc.line(29.87, 85, 79, 85);
    doc.text('IDIOMA: ', 80, 84, { align: 'left' });
    //doc.line(88.93, 85, 145, 85);
    doc.text('NEE: ', 146, 84, { align: 'left' });
    // doc.line(161.6, 85, 200, 85);

    doc.text('CORREO: ', 14, 100, { align: 'left' });
    // let x1 = doc.getTextWidth('CORREO: ')
    // console.log(x1);
    doc.text('TELÉFONO: ', 80, 100, { align: 'left' });
    doc.text('TELÉFONO 2: ', 146, 100, { align: 'left' });
    doc.text('ESTADO: ', 14, 116, { align: 'left' });
    doc.text('MUNICIPIO: ', 80, 116, { align: 'left' });
    doc.text('COLONIA: ', 146, 116, { align: 'left' });
    doc.text('CALLE: ', 14, 122, { align: 'left' });
    doc.text('N° EXT.: ', 146, 122, { align: 'left' });
    doc.text('N° INT: ', 176, 122, { align: 'left' });
    doc.text('REFERENCIAS: ', 14, 128, { align: 'left' });
    doc.text('INSTITUCIÓN DE PROCEDENCIA: ', 14, 144, { align: 'left' });
    doc.text('SECTOR: ', 146, 144, { align: 'left' });
    doc.text('MEDIO DE PROMOCIÓN: ', 14, 150, { align: 'left' });
    //
    doc.setFont("helvetica", "bold");
    doc.text('NOMBRE: ', 14, 166, { align: 'left' });
    doc.text('PARENTESCO: ', 127, 166, { align: 'left' });
    doc.text('TELÉFONO: ', 14, 172, { align: 'left' });
    doc.text('CORREO: ', 127, 172, { align: 'left' });
    doc.text('NOMBRE: ', 14, 184, { align: 'left' });
    doc.text('PARENTESCO: ', 127, 184, { align: 'left' });
    doc.text('TELÉFONO: ', 14, 190, { align: 'left' });
    doc.text('CORREO: ', 127, 190, { align: 'left' });
    doc.text('TIPO DE SANGRE: ', 14, 206, { align: 'left' });
    doc.text('FACTOR RH: ', 80, 206, { align: 'left' });
    doc.text('ALERGIAS: ', 146, 206, { align: 'left' });
    doc.text('ALERGIAS QUE PADECE: ', 14, 212, { align: 'left' });
    doc.text('PADECIMIENTOS: ', 14, 218, { align: 'left' });
    doc.text('CONTACTO MÉDICO: ', 14, 236, { align: 'left' });
    doc.text('TELÉFONO MÉDICO: ', 14, 242, { align: 'left' });
    doc.text('TELÉFONO MÉDICO 2: ', 80, 242, { align: 'left' });
   // doc.text('4A. Oriente Norte \n entre 12 y 13 Norte No.1352 \n Barrio La Pimienta \n CP.29034', 35, 260, { align: 'center' });
   // doc.text('contactoicsmish@gmail.com', 95, 262, { align: 'center' });
   // doc.text('961 125 62 27', 145, 262, { align: 'center' });
   // doc.text('www.icsmish.edu.mx', 195, 262, { align: 'center' });
   // doc.setFillColor(177, 151, 80);
   // doc.rect(5, 270, 206, 3, 'F');
  //  doc.setFillColor(67, 119, 61);
   // doc.rect(5, 273, 206, 3, 'F');

    doc.setFillColor(177, 151, 80);
          doc.setFillColor(245, 73, 39);
      doc.rect(5, 270, 206, 3, 'F');
      doc.setFillColor(67, 119, 61);
          doc.setFillColor(40, 40, 40);
      doc.rect(5, 273, 206, 3, 'F');


    doc.addPage();
    if (logo != "")
      doc.addImage(logo, "PNG", 10, 5, 20, 20, "", "FAST");


    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
    //configuracion de encabezado
    doc.text(this.configuracion.empresa.nombre, width / 2, linea_y, { align: 'center' });
    doc.text(this.configuracion.empresa.subnombre, width / 2, linea_y + 4, { align: 'center' });
    doc.text('CAMPUS '+this.configuracion.sucursal.nombre.toUpperCase(), width / 2, linea_y + 8, { align: 'center' });
    //doc.text('"UNIVERSIDAD DE PUEBLA"', width / 2, linea_y + 4, { align: 'center' });

    doc.text('documentación'.toUpperCase(), width / 2, linea_y + 20, { align: 'center' });
    // doc.text('Inscripción condicionada'.toUpperCase(), width / 2, linea_y + 20, { align: 'center' });
    // doc.text('colegiaturas y becas'.toUpperCase(), width / 2, 84, { align: 'center' });


    doc.setFontSize(6);
    doc.setFont("helvetica", "bold");

    doc.roundedRect(10, 32, 196, 28, 2, 2);



    for (let index = 0; index < this.requisito.length; index++) {

      const form = this.requisito[index];

      for (let j = 0; j < form.formularios_requisitos.length; j++) {
        const element = form.formularios_requisitos[j];
        for (let k = 0; k < element.length; k++) {
          const documento = element[k];
          if (documento.orden <= 3) {
            doc.text(documento.nombre.toUpperCase(), 14 + (k * 65), 38, { align: 'left', maxWidth: 35 });
            doc.rect(49 + (k * 65), 34.5, 4, 4);


          } else if (documento.orden > 3 && documento.orden <= 6) {
            doc.text(documento.nombre.toUpperCase(), 14 + (k * 65), 46, { align: 'left', maxWidth: 35 });
            doc.rect(49 + (k * 65), 43, 4, 4);
          } else {
            doc.text(documento.nombre.toUpperCase(), 14 + (k * 65), 54, { align: 'left', maxWidth: 35 });
            doc.rect(49 + (k * 65), 51, 4, 4);
          }
        }

      }

    }
    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
    let nombre_completo = this.dato.controls.nombre.value + ' ' + this.dato.controls.apellido_paterno.value + ' ' + this.dato.controls.apellido_materno.value;


    if (this.dato.controls.inscripcion_condicionada.value == 0) {

      let texto_x = 0;
      if (this.dato.controls.condicion_adicional.value == 1) {
        doc.roundedRect(10, 64, 196, 18, 2, 2);
        doc.text('Acepta los lineamientos institucionales sobre los documentos que debera presentar en originales en los tiempos que la institución le indique, para la realización de los trámites correspondientes a titulación, de no cumplir con estos requisitos y tiempos acepta las responsabilidades que deriven por dicho incumplimiento', 18, 70, { align: 'justify', maxWidth: 180 })
        texto_x += 86
      } else {
        texto_x += 64
      }


      doc.text('colegiaturas y becas'.toUpperCase(), width / 2, texto_x, { align: 'center' });

      texto_x += 2;
      let elem = document.getElementById("beca");
      let res = (doc as any).autoTableHtmlToJson(elem);
      (doc as any).autoTable(res.columns, [['Plan de pago actual', '$', '$', '$'], ['Beca: ', '$', '$', '$'], ['Importe a pagar', '$', '$', '$']], {
        createdHeaderCell: function (cell, data) {
          cell.styles.halign = "left";
        },
        tableWidth: 187,
        startY: texto_x,
        headStyles: {
          halign: 'center',
          fontSize: 7,
          fillColor: [202, 218, 205],
          textColor: "#000000",

        },

        bodyStyles: {
          fontSize: 7,
          fillColor: "#FFFFFF",
          textColor: "#000000"
        },
        theme: "grid",
        columnStyles: {
          0: { cellWidth: 85 }
        }
      });
      // doc.roundedRect(10, 58, 196, 46, 2, 2);
    } else {

      doc.text('Inscripción condicionada'.toUpperCase(), width / 2, 64, { align: 'center' });
      doc.roundedRect(10, 66, 196, 40, 2, 2);
      doc.setFont("helvetica", "normal");
      doc.text('Quien suscribe', 18, 72, { align: 'left' });
      doc.text('interesado(a) en estudiar en esta institución para el', 119, 72, { align: 'left' });
      doc.text('periodo', 18, 78, { align: 'left' });
      doc.text(',acepto mi inscripción condicionada para ingresar al programa, teniendo en cuenta que debo', 84, 78, { align: 'left' });
      doc.text('entregar para el día', 18, 84, { align: 'left' });
      doc.text('la documentación pendiente.', 62, 84, { align: 'left' });
      doc.setFont("helvetica", "bold");
      let distancia = doc.getTextWidth('entregar para el día')
      // console.log(distancia);

      doc.text('*En caso contrario estoy sabedor de que causaré baja temporal, hasta regularizarme con los documentos que me solicita la institución, Por lo que asumo la responsabilidad total al no egresar en tiempo y forma del ciclo escolar al que se me dio la oportunidad de ingresar, eximiendo de toda responsabilidad al'
        + ' ' + this.configuracion.empresa.nombre + ' '+this.configuracion.empresa.subnombre.toUpperCase(), 18, 92, { align: 'justify', maxWidth: 180 });
      doc.setTextColor(0);

      let texto_x = 0;
      if (this.dato.controls.condicion_adicional.value == 1) {
        doc.roundedRect(10, 110, 196, 18, 2, 2);
        doc.text('Acepta los lineamientos institucionales sobre los documentos que debera presentar en originales en los tiempos que la institución le indique, para la realización de los trámites correspondientes a titulación, de no cumplir con estos requisitos y tiempos acepta las responsabilidades que deriven por dicho incumplimiento', 18, 116, { align: 'justify', maxWidth: 180 })
        texto_x += 132
      } else {
        texto_x += 110
      }
      doc.text('colegiaturas y becas'.toUpperCase(), width / 2, texto_x, { align: 'center' });
      texto_x += 2;
      let elem = document.getElementById("beca");
      let res = (doc as any).autoTableHtmlToJson(elem);

      (doc as any).autoTable(res.columns, [['Plan de pago actual', '$', '$', '$'], ['Beca: ', '$', '$', '$'], ['Importe a pagar', '$', '$', '$']], {
        createdHeaderCell: function (cell, data) {
          cell.styles.halign = "left"; 
        },
        tableWidth: 187,
        startY: texto_x,
        headStyles: {
          halign: 'center',
          fontSize: 7,
          fillColor: [202, 218, 205],
          textColor: "#000000",

        },

        bodyStyles: {
          fontSize: 7,
          fillColor: "#FFFFFF", 
          textColor: "#000000"
        },
        theme: "grid",
        columnStyles: {
          0: { cellWidth: 85 }
        }
      });

    }

    doc.setFontSize(6);
    doc.setDrawColor(0);
    doc.roundedRect(10, doc.lastAutoTable.finalY + 4, 196, 26, 2, 2);
    doc.text('OBSERVACIONES: ', 14, doc.lastAutoTable.finalY + 8, { align: 'left' });
    doc.setFont("helvetica", "bold");
    doc.line(35, 240, 80, 240);

    doc.line(145, 240, 190, 240);
    doc.text(this.usuario.nombre.toUpperCase(), 167.5, 243, { align: 'center', maxWidth: 45 });

    //doc.text('4A. Oriente Norte \n entre 12 y 13 Norte No.1352 \n Barrio La Pimienta \n CP.29034', 35, 260, { align: 'center' });
    //doc.text('contactoicsmish@gmail.com', 95, 262, { align: 'center' });
    //doc.text('961 125 62 27', 145, 262, { align: 'center' });
   // doc.text('www.icsmish.edu.mx', 195, 262, { align: 'center' });
  //  doc.setFillColor(177, 151, 80);
   // doc.rect(5, 270, 206, 3, 'F');
   // doc.setFillColor(67, 119, 61);
   // doc.rect(5, 273, 206, 3, 'F');

      doc.setFillColor(177, 151, 80);
          doc.setFillColor(245, 73, 39);
      doc.rect(5, 270, 206, 3, 'F');
      doc.setFillColor(67, 119, 61);
          doc.setFillColor(40, 40, 40);
      doc.rect(5, 273, 206, 3, 'F');

    window.open(doc.output('bloburl'), '_blank');
  }
}
